const es = {
  'common.loading': 'Cargando…',
  'common.save': 'Guardar',
  'common.saving': 'Guardando…',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.search': 'Buscar',
  'common.sortBy': 'Ordenar por',
  'common.never': 'Nunca',
  'common.justNow': 'Ahora mismo',
  'common.accessDenied': 'Acceso denegado',
  'common.backToLogin': 'Volver al inicio de sesión',
  'common.markAsRead': 'Marcar como leído',
  'common.user': 'Usuario',
  'shell.supportDesk': 'Centro de soporte',
  'shell.searchPlaceholder': 'Buscar tickets, contactos, artículos…',
  'shell.newTicket': 'Nuevo ticket',
  'shell.notifications': 'Notificaciones',
  'shell.notificationPreferences': 'Preferencias de notificaciones',
  'shell.settings': 'Configuración',
  'shell.signOut': 'Cerrar sesión',
  'shell.expandNavigation': 'Expandir navegación',
  'shell.collapseNavigation': 'Contraer navegación',
  'shell.adminNavigation': 'Navegación de administración',
  'shell.caughtUp': 'Estás al día',
  'shell.viewAllNotifications': 'Ver todas las notificaciones',
  'nav.dashboard': 'Panel',
  'nav.tickets': 'Tickets',
  'nav.contacts': 'Contactos',
  'nav.companies': 'Empresas',
  'nav.reports': 'Informes',
  'nav.settings': 'Configuración',
  'nav.agents': 'Agentes',
  'nav.groups': 'Grupos',
  'nav.roles': 'Roles',
  'nav.tags': 'Etiquetas',
  'nav.ticketFields': 'Campos del ticket',
  'nav.ticketForms': 'Formularios de ticket',
  'nav.businessHours': 'Horario laboral',
  'nav.slaPolicies': 'Políticas de SLA',
  'nav.automations': 'Automatizaciones',
  'nav.email': 'Correo electrónico',
  'nav.notificationTemplates': 'Plantillas de notificación',
  'nav.apiKeys': 'Claves API',
  'nav.cannedResponses': 'Respuestas guardadas',
  'nav.knowledgeBase': 'Base de conocimiento',
  'auth.signInTitle': 'Centro de soporte SDPL',
  'auth.signInSubtitle': 'Inicia sesión en tu cuenta',
  'auth.emailAddress': 'Dirección de correo',
  'auth.password': 'Contraseña',
  'auth.signingIn': 'Iniciando sesión…',
  'auth.signIn': 'Iniciar sesión',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.twoFactor': 'Autenticación de dos factores',
  'auth.verificationCode': 'Código de verificación',
  'auth.verify': 'Verificar',
  'auth.backToLogin': 'Volver al inicio de sesión',
  'agents.title': 'Agentes',
  'agents.new': 'Nuevo agente',
  'agents.supportAgents': 'Agentes de soporte',
  'agents.collaborators': 'Colaboradores',
  'agents.deactivated': 'Desactivados',
  'agents.searchPlaceholder': 'Buscar por nombre o correo',
  'agents.noSearchResults': 'Ningún agente coincide con esta búsqueda',
  'agents.noAgentsView': 'No hay agentes en esta vista',
  'agents.edit': 'Editar',
  'agents.deactivate': 'Desactivar',
  'agents.reactivate': 'Reactivar',
  'agents.saved': 'Agente guardado.',
  'agents.firstName': 'Nombre',
  'agents.lastName': 'Apellidos',
  'agents.email': 'Correo electrónico',
  'agents.phone': 'Teléfono',
  'agents.timezone': 'Zona horaria',
  'agents.selectTimezone': 'Seleccionar zona horaria',
  'agents.language': 'Idioma',
  'agents.selectLanguage': 'Seleccionar idioma',
  'agents.emailSignature': 'Firma de correo',
  'agents.roleRequired': 'Rol',
  'agents.selectRole': 'Seleccionar rol',
  'agents.status': 'Estado',
  'agents.groupsTitle': 'Grupos',
  'agents.manageGroups': 'Gestionar grupos',
  'agents.notInGroup': 'Todavía no pertenece a ningún grupo',
  'dashboard.title': 'Panel',
  'dashboard.description': 'Carga de soporte y estado del servicio actuales.',
  'dashboard.allGroups': 'Todos los grupos accesibles',
  'dashboard.unresolved': 'Sin resolver',
  'dashboard.overdue': 'Vencidos',
  'dashboard.dueToday': 'Vencen hoy',
  'dashboard.open': 'Abiertos',
  'dashboard.onHold': 'En espera',
  'dashboard.unassigned': 'Sin asignar',
  'dashboard.trends': 'Tendencias de hoy',
  'dashboard.today': 'Hoy',
  'dashboard.yesterday': 'Ayer',
  'notifications.title': 'Notificaciones',
  'notifications.description': 'Tu historial completo de notificaciones.',
  'notifications.markAllRead': 'Marcar todo como leído',
  'notifications.filter': 'Filtro',
  'notifications.allTypes': 'Todos los tipos',
  'notifications.none': 'Aún no hay notificaciones',
  'notifications.assigned': 'Asignado',
  'notifications.reply': 'Respuesta',
  'notifications.note': 'Nota',
  'notifications.slaWarning': 'Aviso de SLA',
  'notifications.slaBreach': 'Incumplimiento de SLA',
  'notifications.slaEscalation': 'Escalación de SLA',
  'notifications.mention': 'Mención',
  'preferences.title': 'Preferencias de notificaciones',
  'preferences.description': 'Las notificaciones de la aplicación siempre están activas. Elige cuáles también envían un correo.',
  'preferences.emailDigest': 'Resumen por correo',
  'preferences.dailySummary': 'Recibe un resumen diario en lugar de un correo por cada evento.',
  'preferences.digestOff': 'Desactivado — correo para cada evento',
  'preferences.digestDaily': 'Resumen diario',
  'preferences.emailNotifications': 'Notificaciones por correo',
  'activities.button': 'Actividad reciente',
  'activities.title': 'Actividad reciente',
  'activities.loadError': 'No se pudo cargar la actividad reciente.',
  'activities.systemActor': 'Sistema',
  'activities.noneTitle': 'Todavía no hay actividad reciente',
  'activities.noneDescription': 'Las actualizaciones de tickets suyas y de su grupo aparecerán aquí a medida que ocurran.',
  'tickets.title': 'Tickets',
  'tickets.description': 'Todos los tickets a los que tiene acceso, filtrados y ordenados a su manera.',
  'tickets.dueDateTabs': 'Fecha límite del ticket',
  'tickets.tabAll': 'Todos los tickets',
  'tickets.tabDueToday': 'Vence hoy',
  'tickets.tabOverdue': 'Vencidos',
  'tickets.tabDueTomorrow': 'Vence mañana',
  'tickets.searchPlaceholder': 'Buscar tickets…',
  'tickets.searchAria': 'Buscar tickets',
  'tickets.filters': 'Filtros',
  'tickets.filtersWithCount': 'Filtros ({count})',
  'tickets.sortAria': 'Ordenar tickets por',
  'tickets.sortTrigger': 'Ordenar: {label}',
  'tickets.sortDateCreated': 'Fecha de creación',
  'tickets.sortDateUpdated': 'Fecha de actualización',
  'tickets.sortPriority': 'Prioridad',
  'tickets.sortStatus': 'Estado',
  'tickets.sortDueDate': 'Fecha límite',
  'tickets.sortAscending': 'Orden ascendente',
  'tickets.sortDescending': 'Orden descendente',
  'tickets.ascending': 'Ascendente',
  'tickets.descending': 'Descendente',
  'tickets.layoutAria': 'Diseño de filas',
  'tickets.layoutTrigger': 'Diseño: {label}',
  'tickets.layoutCard': 'Tarjeta',
  'tickets.layoutInbox': 'Bandeja de entrada',
  'tickets.layoutTable': 'Tabla',
  'tickets.export': 'Exportar',
  'tickets.exportSelected': 'Exportar seleccionados',
  'tickets.selectedCount': '{count} seleccionados',
  'tickets.assignAgent': 'Asignar agente',
  'tickets.closeAll': 'Cerrar todos',
  'tickets.clearSelection': 'Borrar selección',
  'tickets.selectAgentPlaceholder': 'Seleccionar agente...',
  'tickets.assignTo': 'Asignar a',
  'tickets.assign': 'Asignar',
  'tickets.loadFailed': 'No se pudieron cargar los tickets. Inténtelo de nuevo.',
  'tickets.bulkCloseFailed': 'No se pudieron cerrar los tickets seleccionados. Inténtelo de nuevo.',
  'tickets.bulkAssignFailed': 'No se pudieron asignar los tickets seleccionados. Inténtelo de nuevo.',
  'tickets.noFilterMatchTitle': 'Ningún ticket coincide con estos filtros',
  'tickets.noFilterMatchDescription': 'Intente quitar un filtro, ampliar el rango de fechas o buscar otro término.',
  'tickets.clearFilters': 'Borrar filtros',
  'tickets.queueClearTitle': 'Esta cola está despejada',
  'tickets.queueClearDescription': 'Los tickets nuevos aparecerán aquí cuando un cliente escriba por correo, use el portal o un agente cree uno.',
  'tickets.newTicket': 'Nuevo ticket',
  'tickets.selectAllAria': 'Seleccionar todos los tickets',
  'tickets.selectTicketAria': 'Seleccionar ticket n.º {number}',
  'tickets.columnContact': 'Contacto',
  'tickets.columnSubject': 'Asunto',
  'tickets.columnState': 'Estado',
  'tickets.columnGroup': 'Grupo',
  'tickets.columnAgent': 'Agente',
  'tickets.columnPriority': 'Prioridad',
  'tickets.noGroup': 'Sin grupo',
  'tickets.unassigned': 'Sin asignar',
  'tickets.createdRelative': 'Creado {when}',
  'tickets.unassignedOnly': 'Solo sin asignar',
  'tickets.unknownRequester': 'Solicitante desconocido',
  'tickets.overdueBy': 'Vencido hace {duration}',
  'tickets.dueIn': 'Vence en {duration}',
  'tickets.filtersDrawerTitle': 'Filtros',
  'tickets.filtersSearchPlaceholder': 'Buscar campos',
  'tickets.filtersSearchAria': 'Buscar campos de filtro',
  'tickets.filtersClearAll': 'Borrar todo',
  'tickets.filtersApply': 'Aplicar',
  'tickets.filterAgents': 'Agentes',
  'tickets.filterAnyAgent': 'Cualquier agente',
  'tickets.filterGroups': 'Grupos',
  'tickets.filterAnyGroup': 'Cualquier grupo',
  'tickets.filterStatus': 'Estado',
  'tickets.filterAnyStatus': 'Cualquier estado',
  'tickets.filterPriority': 'Prioridad',
  'tickets.filterAnyPriority': 'Cualquier prioridad',
  'tickets.filterSource': 'Origen',
  'tickets.filterAnySource': 'Cualquier origen',
  'tickets.filterTicketType': 'Tipo de ticket',
  'tickets.filterAnyType': 'Cualquier tipo',
  'tickets.filterTags': 'Etiquetas',
  'tickets.filterAnyTag': 'Cualquier etiqueta',
  'tickets.filterCompanies': 'Empresas',
  'tickets.filterAnyCompany': 'Cualquier empresa',
  'tickets.filterCreated': 'Creado',
  'tickets.filterResolvedAt': 'Resuelto el',
  'tickets.filterClosedAt': 'Cerrado el',
  'tickets.filterDateFrom': '{label} desde',
  'tickets.filterDateTo': '{label} hasta',
  'tickets.filterDateTo2': 'hasta',
  'tickets.filterAny': 'Cualquiera',
  'tickets.chipFieldStatus': 'Estado',
  'tickets.chipFieldPriority': 'Prioridad',
  'tickets.chipFieldGroup': 'Grupo',
  'tickets.chipFieldAssignee': 'Responsable',
  'tickets.chipValueGroup': 'Grupo',
  'tickets.chipValueUnassigned': 'Sin asignar',
  'common.clearSearch': 'Borrar búsqueda',
  'common.name': 'Nombre',
  'common.role': 'Rol',
  'common.groups': 'Grupos',
  'common.tickets': 'Tickets',
  'common.lastSeen': 'Última actividad',
  'common.actions': 'Acciones',
  'common.minutesAgo': 'hace {count} min',
  'common.hoursAgo': 'hace {count} h',
  'common.daysAgo': 'hace {count} d',
  'common.noPagePermission': 'No tiene permiso para acceder a esta página.',
  'common.roleNoPermission': 'Su rol no tiene permiso para acceder a esta página.',
  'common.requestFailed': 'La solicitud falló. Inténtelo de nuevo.',
  'common.unexpectedError': 'Se produjo un error inesperado',
  'shell.skipToMain': 'Saltar al contenido principal',
  'shell.homeLabel': 'Inicio de Suzuki Support Desk',
  'shell.userMenu': 'Menú de usuario',
  'shell.unread': '{count} sin leer',
  'shell.notificationDescription': 'Las nuevas asignaciones, respuestas y alertas de SLA aparecerán aquí.',
  'auth.enterAuthenticatorCode': 'Introduzca el código de 6 dígitos de su aplicación de autenticación',
  'auth.verifying': 'Verificando…',
  'auth.setupAuthenticator': 'Configurar autenticador',
  'auth.scanAuthenticator': 'Escanee este código con su aplicación de autenticación (Google Authenticator, Authy, etc.)',
  'auth.authenticatorSetupQr': 'Código QR de configuración del autenticador',
  'auth.verificationCodeFromAuthenticator': 'Código de verificación del autenticador',
  'auth.verifyAndComplete': 'Verificar y completar la configuración',
  'auth.loadingSetup': 'Cargando configuración…',
  'auth.setNewPassword': 'Establecer nueva contraseña',
  'auth.temporaryPasswordExpired': 'Su contraseña temporal ha expirado. Establezca una nueva contraseña.',
  'auth.newPassword': 'Nueva contraseña',
  'auth.confirmPassword': 'Confirmar contraseña',
  'auth.settingPassword': 'Estableciendo contraseña…',
  'auth.setPassword': 'Establecer contraseña',
  'auth.passwordRequirements': 'Se requieren al menos 8 caracteres, mayúsculas, minúsculas, número y símbolo',
  'auth.tooManyAttempts': 'Demasiados intentos de inicio de sesión. Inténtelo más tarde.',
  'auth.invalidCredentials': 'Correo o contraseña inválidos',
  'auth.passwordsDoNotMatch': 'Las contraseñas no coinciden',
  'auth.passwordMinimum': 'La contraseña debe tener al menos {count} caracteres',
  'auth.resetTitle': 'Restablezca su contraseña',
  'auth.resetSubtitle': 'Introduzca su correo y le enviaremos un enlace para restablecerla',
  'auth.checkEmail': 'Revise su correo para el enlace de restablecimiento',
  'auth.checkCode': 'Revise su correo para obtener el código de verificación y continúe abajo.',
  'auth.continueToReset': 'Continuar para restablecer la contraseña',
  'auth.sendResetLink': 'Enviar enlace de restablecimiento',
  'auth.sending': 'Enviando…',
  'auth.resetSuccess': 'Su contraseña se ha restablecido correctamente.',
  'auth.goToLogin': 'Ir al inicio de sesión',
  'auth.missingResetToken': 'Falta el token de restablecimiento. Utilice el enlace de su correo.',
  'auth.enterCodeFromEmail': 'Introduzca el código de verificación enviado a su correo',
  'auth.codeFromEmail': 'Introducir código del correo',
  'auth.emailRequired': 'El correo es obligatorio',
  'auth.codeRequired': 'El código de verificación es obligatorio',
  'auth.missingToken': 'Falta el token de restablecimiento',
  'auth.failedReset': 'No se pudo restablecer la contraseña.',
  'auth.resetting': 'Restableciendo…',
  'auth.resetPassword': 'Restablecer contraseña',
  'auth.looksGood': 'Se ve bien',
  'auth.needCharacters': 'Se necesitan al menos {count} caracteres',
  'auth.passwordFormat': 'Se requieren al menos {count} caracteres, mayúsculas, minúsculas, número y símbolo',
  'agents.description': 'Personas que gestionan tickets. Asigne un rol para controlar lo que pueden hacer y grupos para controlar lo que ven.',
  'agents.searchAria': 'Buscar agentes',
  'agents.countOne': '{count} agente',
  'agents.countMany': '{count} agentes',
  'agents.ticketOne': '{count} ticket',
  'agents.ticketMany': '{count} tickets',
  'agents.noGroups': 'Sin grupos',
  'agents.lifecycle': 'Ciclo de vida del agente',
  'agents.tryDifferent': 'Pruebe con un nombre o correo diferente.',
  'agents.useNewAgent': 'Use Nuevo agente para agregar a alguien, o cambie de pestaña para ver otros agentes.',
  'agents.agent': 'Agente',
  'agents.noRole': 'Sin rol',
  'agents.openTicketsTitle': 'Tickets abiertos actualmente asignados a este agente',
  'agents.moreActions': 'Más acciones para {name}',
  'agents.confirmDeleteTitle': '¿Eliminar a {name}?',
  'agents.confirmDeleteDescription': 'Esto no se puede deshacer. Los agentes vinculados a tickets no se pueden eliminar; desactívelos en su lugar.',
  'agents.confirmDeleteLabel': 'Eliminar agente',
  'agents.agentsVsCollaborators': 'Agentes frente a colaboradores',
  'agents.agentsVsCollaboratorsBody': 'Los agentes de soporte gestionan tickets a diario. Los colaboradores tienen un rol de colaborador y suelen ser expertos que participan en tickets individuales sin acceso completo de agente.',
  'agents.deactivateVsDelete': 'Desactivar frente a eliminar',
  'agents.deactivateVsDeleteBody': 'Desactivar conserva el historial y la propiedad de los tickets, pero bloquea el inicio de sesión. Eliminar es permanente y solo funciona cuando el agente no tiene tickets vinculados.',
  'agents.newTitle': 'Nuevo agente',
  'agents.editTitle': 'Editar agente',
  'agents.temporaryPassword': 'Contraseña temporal',
  'agents.passwordHelp': 'Al menos 12 caracteres. El agente puede cambiarla después de iniciar sesión.',
  'agents.timezoneHelp': 'Cada fecha y hora que ve este agente se muestra en esta zona horaria.',
  'agents.languageHelp': 'Traduce la interfaz orientada al agente. Las respuestas de tickets y el contenido del cliente no se traducen.',
  'agents.signaturePlaceholder': 'Se añade a las respuestas salientes',
  'agents.roleHelp': 'Determina lo que este agente puede hacer.',
  'agents.manageRoles': 'Gestionar roles',
  'agents.activeHelp': 'Activo — desmarcar bloquea el inicio de sesión sin eliminar al agente',
  'agents.groupHelp': 'Agregue este agente a un grupo desde la pantalla de Grupos para controlar qué tickets ve.',
  'agents.about': 'Acerca de este agente',
  'agents.aboutBody': 'El nombre, correo, teléfono, zona horaria, idioma y firma identifican al agente y personalizan su espacio de trabajo. El rol determina lo que puede hacer; la pertenencia al grupo determina qué tickets ve.',
  'dashboard.trendsDescription': 'Creación de tickets por hora UTC, comparada con ayer.',
  'dashboard.chartAria': 'Volumen de tickets por hora UTC, hoy frente a ayer',
  'dashboard.dataUnavailable': 'Los datos del panel no están disponibles.',
  'dashboard.loadError': 'No se pudieron cargar los datos del panel. Inténtelo de nuevo.',
  'notifications.noType': 'No hay notificaciones de este tipo',
  'notifications.allTypesHint': 'Elija "Todos los tipos" arriba para ver el resto de su historial.',
  'notifications.emptyDescription': 'Las asignaciones, respuestas y alertas de SLA aparecen aquí. Ajuste cuáles de ellas le envían correo en las preferencias de notificaciones.',
  'preferences.digestWarning': 'Tiene activado el resumen diario, así que estos ajustes se ignoran hasta que lo desactive.',
  'preferences.assignedEvent': 'Se le asigna un ticket',
  'preferences.replyEvent': 'Un ticket en el que participa recibe una respuesta',
  'preferences.noteEvent': 'Se añade una nota privada',
  'preferences.slaWarningEvent': 'El SLA se acerca a su plazo',
  'preferences.slaBreachEvent': 'Se incumple el SLA',
  'preferences.slaEscalationEvent': 'El SLA escala tras el plazo',
  'preferences.mentionEvent': 'Le mencionan en un ticket',

  'ticketDetail.back': 'Volver',
  'ticketDetail.follow': 'Seguir',
  'ticketDetail.following': 'Siguiendo',
  'ticketDetail.hideActivities': 'Ocultar actividades',
  'ticketDetail.activitiesButton': 'Actividades',
  'ticketDetail.attachmentsCount': 'Adjuntos ({count})',
  'ticketDetail.threadAria': 'Hilo del ticket',
  'ticketDetail.conversationsTabLabel': 'Conversaciones',
  'ticketDetail.activitiesTabLabel': 'Actividades',
  'ticketDetail.noRepliesYet': 'Aún no hay respuestas',
  'ticketDetail.noRepliesDescription': 'Use el editor de abajo para responder al solicitante o añadir una nota interna.',
  'ticketDetail.privateNote': 'Nota privada',
  'ticketDetail.forward': 'Reenviado',
  'ticketDetail.uploadingAria': 'Subiendo',
  'ticketDetail.uploadingProgress': 'Subiendo {uploading} de {total} archivo(s)…',
  'ticketDetail.uploadsFailed': '{count} carga(s) fallida(s)',
  'ticketDetail.retry': 'Reintentar',
  'ticketDetail.dismiss': 'Descartar',
  'ticketDetail.noActivityYet': 'Aún no hay actividad',
  'ticketDetail.noActivityDescription': 'Los cambios de estado, agente y SLA se mostrarán aquí a medida que avance el ticket.',
  'ticketDetail.requester': 'Solicitante',
  'ticketDetail.properties': 'Propiedades',
  'ticketDetail.updating': 'Actualizando…',
  'ticketDetail.update': 'Actualizar',
  'ticketDetail.tags': 'Etiquetas',
  'ticketDetail.relationships': 'Relaciones',
  'ticketDetail.parentTicket': 'Ticket principal',
  'ticketDetail.unlink': 'Desvincular',
  'ticketDetail.noParentTicket': 'Sin ticket principal',
  'ticketDetail.childTicketsCount': 'Tickets secundarios ({count})',
  'ticketDetail.noChildTickets': 'Sin tickets secundarios',
  'ticketDetail.findTicket': 'Buscar un ticket',
  'ticketDetail.ticketSearchPlaceholder': 'Número de ticket o asunto',
  'ticketDetail.searchButton': 'Buscar',
  'ticketDetail.setParent': 'Establecer como principal',
  'ticketDetail.mergeIntoAction': 'Fusionar con',
  'ticketDetail.splitIntoChild': 'Dividir en un ticket secundario',
  'ticketDetail.newTicketSubjectPlaceholder': 'Asunto del nuevo ticket',
  'ticketDetail.splitButton': 'Dividir',
  'ticketDetail.copyAttachments': 'Copiar adjuntos',
  'ticketDetail.copyConversationHistory': 'Copiar historial de conversación',
  'ticketDetail.slaLabel': 'SLA',
  'ticketDetail.paused': 'En pausa',
  'ticketDetail.editButton': 'Editar',
  'ticketDetail.setResolutionDueDate': 'Establecer fecha límite de resolución',
  'ticketDetail.pickDateTime': 'Elegir fecha y hora',
  'ticketDetail.resolutionDueLabel': 'Fecha límite de resolución',
  'ticketDetail.saveSla': 'Guardar SLA',
  'ticketDetail.savingSla': 'Guardando…',
  'ticketDetail.noSlaPolicy': 'No hay política de SLA aplicada a este ticket.',
  'ticketDetail.firstResponse': 'Primera respuesta',
  'ticketDetail.resolution': 'Resolución',
  'ticketDetail.done': 'Hecho',
  'ticketDetail.pausedSince': 'En pausa desde {date}',
  'ticketDetail.escalation': 'Escalación',
  'ticketDetail.escalatedLevel2': 'Escalado (Nivel 2)',
  'ticketDetail.escalated': 'Escalado',
  'ticketDetail.dueDateOverridden': 'Fecha límite modificada manualmente por un administrador.',
  'ticketDetail.dates': 'Fechas',
  'ticketDetail.created': 'Creado',
  'ticketDetail.updated': 'Actualizado',
  'ticketDetail.resolved': 'Resuelto',
  'ticketDetail.closed': 'Cerrado',
  'ticketDetail.loadErrorTitle': 'No se pudo cargar este ticket',
  'ticketDetail.notFound': 'Ticket no encontrado',
  'ticketDetail.confirmMergeTitle': '¿Fusionar el ticket n.º {source} con el n.º {target}?',
  'ticketDetail.confirmMergeDescription': 'El ticket actual se cerrará. Esta acción no se puede deshacer.',
  'ticketDetail.confirmMergeLabel': 'Fusionar ticket',
  'ticketDetail.updateSuccess': 'Ticket actualizado',
  'ticketDetail.updateError': 'No se pudo actualizar el ticket',
  'ticketDetail.pickDateTitle': 'Elija una fecha',
  'ticketDetail.pickDateDescription': 'Elija una fecha límite de resolución.',
  'ticketDetail.slaUpdateSuccess': 'SLA actualizado',
  'ticketDetail.slaUpdateError': 'No se pudo actualizar el SLA',
  'ticketDetail.searchError': 'No se pudieron buscar tickets',
  'ticketDetail.parentUpdateError': 'No se pudo actualizar el ticket principal',
  'ticketDetail.mergeSuccess': 'Fusionado con el n.º {number}',
  'ticketDetail.mergeError': 'No se pudo fusionar el ticket',
  'ticketDetail.splitSuccess': 'División de ticket creada',
  'ticketDetail.splitError': 'No se pudo dividir el ticket',
  'ticketDetail.downloadError': 'No se pudo descargar el adjunto',
  'ticketDetail.followSuccess': 'Ahora sigue el ticket',
  'ticketDetail.unfollowSuccess': 'Dejó de seguir el ticket',
  'ticketDetail.watcherError': 'No se pudo actualizar el estado de seguimiento',
  'ticketDetail.fieldsLoadError': 'No se pudieron cargar los campos del ticket',
  'ticketDetail.overdueBy': 'Vencido hace {label}',
  'ticketDetail.dueLeft': '{label} restante',
  'ticketDetail.presetToday': 'Hoy',
  'ticketDetail.presetTomorrow': 'Mañana',
  'ticketDetail.presetThisWeek': 'Esta semana',
  'ticketDetail.presetNextWeek': 'Próxima semana',
  'ticketDetail.presetThisMonth': 'Este mes',
  'ticketDetail.eventTicketCreated': 'Ticket creado',
  'ticketDetail.eventStatusUpdated': 'Estado actualizado',
  'ticketDetail.eventAgentUpdated': 'Agente actualizado',
  'ticketDetail.eventSlaUpdated': 'SLA actualizado',
  'ticketDetail.eventTicketMerged': 'Ticket fusionado',
  'ticketDetail.eventMergeReceived': 'Fusión recibida',
  'ticketDetail.eventTicketSplit': 'Ticket dividido',
  'ticketDetail.eventUpdated': 'Actualizado',
  'ticketDetail.eventSplitContentCopied': 'Contenido dividido copiado',
  'ticketDetail.eventReplySent': 'Respuesta enviada',
  'ticketDetail.eventNoteAdded': 'Nota añadida',
  'ticketDetail.eventCustomerReplied': 'El cliente respondió',
  'ticketDetail.eventTicketDeleted': 'Ticket eliminado',
  'preferences.createdEvent': 'Se creó un ticket',
  'preferences.pendingInputEvent': 'Un ticket espera tu respuesta',
  'preferences.resolvedEvent': 'Un ticket está resuelto',
  'agents.assignGroups': 'Asignar grupos',
  'agents.assignGroupsHelp': 'La pertenencia a grupos controla qué tickets puede ver este agente.',
  'agents.selectGroups': 'Seleccionar grupos',
  'agents.ticketVisibility': 'Visibilidad de tickets',
  'agents.ticketVisibilityHelp': 'Elige un límite más restringido por agente o hereda el valor predeterminado del rol. Los permisos del rol siguen controlando lo que el agente puede hacer.',
  'agents.scopeRoleDefault': 'Usar valor predeterminado del rol',
  'agents.scopeRoleDefaultHelp': 'Heredar la visibilidad predeterminada configurada para este rol.',
  'agents.scopeAll': 'Todos los tickets',
  'agents.scopeAllHelp': 'Ver todos los tickets no eliminados de esta cuenta.',
  'agents.scopeGroup': 'Tickets de un grupo',
  'agents.scopeGroupHelp': 'Ver tickets asignados a los grupos a los que pertenece este agente.',
  'agents.scopeAssigned': 'Tickets asignados',
  'agents.scopeAssignedHelp': 'Ver tickets asignados directamente a este agente.',
  'agents.scopeCollaboratorHelp': 'Los colaboradores siguen limitados a los tickets de sus grupos L1.',
  'nav.jira': 'Integración con Jira',
  'notifications.groupAssigned': 'Asignación de grupo',
  'notifications.groupMemberAdded': 'Añadido a un grupo',
  'preferences.groupAssignedEvent': 'Se asigna un ticket a uno de tus grupos',
  'preferences.groupMemberAddedEvent': 'Te añaden a un grupo de soporte',
  'ui.select': 'Seleccionar…',
  'ui.any': 'Cualquiera',
  'ui.typeToSearch': 'Escribe para buscar…',
  'ui.noResults': 'No se encontraron resultados',
  'ui.clearSelection': 'Borrar selección',
  'ui.removeItem': 'Quitar {label}',
  'ui.pressEnterToUse': 'Pulsa Intro para usar este valor',
  'ui.removeFilter': 'Quitar filtro {field}: {value}',
  'ui.removeTag': 'Quitar etiqueta {label}',
  'ui.retry': 'Reintentar',
  'ui.errorTitle': 'No se pudo cargar este contenido',
  'ui.errorMessage': 'Comprueba tu conexión e inténtalo de nuevo.',
  'ui.reference': 'Referencia: {id}',
  'ui.thisArea': 'esta área',
  'ui.noAccess': 'No tienes acceso a {area}',
  'ui.noAccessHint': 'Pide a un administrador que te conceda el permiso necesario.',
  'ui.actionFailed': 'No se pudo completar esta acción. Inténtalo de nuevo.',
  'ui.slaPaused': 'SLA en pausa',
  'ui.filteredEmptyTitle': 'Ningún ticket coincide con estos filtros',
  'ui.filteredEmptyDescription': 'Prueba a quitar un filtro o ampliar el intervalo de fechas.',
  'ui.clearFilters': 'Borrar filtros',
  'pagination.noResults': 'Sin resultados',
  'pagination.showing': 'Mostrando {first}–{last} de {total}',
  'pagination.resultsPerPage': 'Resultados por página',
  'pagination.perPage': '{count} por página',
  'pagination.previous': 'Anterior',
  'pagination.next': 'Siguiente',
  'pagination.previousAria': 'Página anterior',
  'pagination.nextAria': 'Página siguiente',
  'pagination.pageOf': 'Página {page} de {total}',
  'status.open': 'Abierto',
  'status.to_be_prioritised': 'Pendiente de priorizar',
  'status.work_in_progress': 'En curso',
  'status.assigned_to_ai_agent': 'Asignado a agente de IA',
  'status.cto_approval_pending': 'CTO Approval Pending',
  'status.po_approval_pending': 'PO Approval Pending',
  'status.rm_approval_pending': 'RM Approval Pending',
  'status.rework_required': 'Rework Required',
  'status.approved': 'Approved',
  'status.rejected': 'Rejected',
  'status.pending': 'Pendiente',
  'status.awaiting_user_reply': 'Esperando respuesta del usuario',
  'status.awaiting_resolution_confirmation': 'Esperando confirmación de resolución',
  'status.on_hold': 'En espera',
  'status.pending_production_release': 'Pendiente de lanzamiento a producción',
  'status.product_cr': 'CR de producto',
  'status.reopened': 'Reabierto',
  'status.issue_fixed': 'Incidencia corregida',
  'status.resolved': 'Resuelto',
  'status.closed': 'Cerrado',
  'status.unknown': 'Desconocido',
  'priority.low': 'Baja',
  'priority.medium': 'Media',
  'priority.high': 'Alta',
  'priority.urgent': 'Urgente',
  'source.email': 'Correo electrónico',
  'source.portal': 'Portal',
  'source.phone': 'Teléfono',
  'source.chat': 'Chat',
  'source.whatsapp': 'WhatsApp',
  'source.web_chat': 'Chat web',
  'source.web_form': 'Formulario web',
  'source.forum': 'Foro',
  'source.facebook': 'Facebook',
  'source.mobihelp': 'MobiHelp',
  'source.feedback_widget': 'Widget de comentarios',
  'source.outbound_email': 'Correo saliente',
  'source.ecommerce': 'Comercio electrónico',
  'source.bot': 'Bot',
  'source.instagram_message': 'Mensaje de Instagram',
  'source.instagram_comment': 'Comentario de Instagram',
  'source.facebook_message': 'Mensaje de Facebook',
  'source.facebook_comment': 'Comentario de Facebook',
  'source.mobile_chat_sdk': 'Mobile Chat SDK',
  'source.sms': 'SMS',
  'source.api': 'API',
  'savedViews.title': 'Vistas guardadas',
  'savedViews.saveCurrent': 'Guardar los filtros actuales como vista',
  'savedViews.namePlaceholder': 'Nombre de la vista...',
  'savedViews.nameAria': 'Nombre de la vista',
  'savedViews.empty': 'No hay vistas guardadas. Aplica filtros y guárdalos aquí.',
  'savedViews.listAria': 'Lista de vistas guardadas',
  'savedViews.rename': 'Renombrar la vista «{name}»',
  'savedViews.delete': 'Eliminar la vista «{name}»',
  'export.title': 'Exportar tickets',
  'export.loadError': 'No se pudo cargar la lista de campos de exportación.',
  'export.failed': 'La exportación falló. Inténtalo de nuevo.',
  'export.pdfFailed': 'La exportación a PDF falló. Inténtalo de nuevo.',
  'export.fieldsSelectedOne': '{count} campo seleccionado',
  'export.fieldsSelectedMany': '{count} campos seleccionados',
  'export.fieldsTotalOne': '{count} campo en total',
  'export.fieldsTotalMany': '{count} campos en total',
  'export.selectAllFields': 'Seleccionar todos los campos',
  'export.exportingOne': 'Exportando 1 ticket seleccionado.',
  'export.exportingMany': 'Exportando {count} tickets seleccionados.',
  'export.pdfZip': 'Descargar como PDF (.zip, {count} archivos)',
  'export.pdf': 'Descargar como PDF',
  'export.pdfZipHint': 'Genera un PDF por ticket y los comprime en una única descarga ZIP.',
  'export.pdfHint': 'Genera un único PDF con las propiedades del ticket y la conversación pública.',
  'export.formatLabel': 'Exportar como (CSV / Excel)',
  'export.csv': 'CSV',
  'export.excel': 'Excel',
  'export.loadingFields': 'Cargando lista de campos…',
  'export.ticketFields': 'Campos del ticket',
  'export.contactFields': 'Campos del contacto',
  'export.companyFields': 'Campos de la empresa',
  'export.exporting': 'Exportando…',
  'newTicket.title': 'Crear ticket',
  'newTicket.description': 'Elige un formulario guardado y completa sus campos.',
  'newTicket.form': 'Formulario de ticket',
  'newTicket.noForms': 'No hay formularios de ticket disponibles. Configura un formulario antes de crear un ticket.',
  'newTicket.loadFormsError': 'No se pudieron cargar los formularios de ticket',
  'newTicket.loadFormError': 'No se pudo cargar el formulario de ticket seleccionado',
  'newTicket.addCc': 'Añadir CC',
  'newTicket.cc': 'CC',
  'newTicket.removeFile': 'Quitar {name}',
  'newTicket.requesterRequired': 'El solicitante es obligatorio',
  'newTicket.subjectRequired': 'El asunto es obligatorio',
  'newTicket.createFailed': 'No se pudo crear el ticket',
  'newTicket.noFormTitle': 'No hay ningún formulario de ticket disponible',
  'newTicket.noFormDescription': 'Crea un formulario de ticket en Configuración y vuelve para abrir un ticket.',
  'newTicket.noFieldsTitle': 'Este formulario aún no tiene campos',
  'newTicket.noFieldsDescription': 'Añade campos al formulario en Configuración y vuelve a cargar esta página.',
  'newTicket.creating': 'Creando...',
  'newTicket.submit': 'Crear ticket',
  'fields.required': '{label} es obligatorio',
  'fields.selectParentFirst': 'Selecciona primero un valor principal...',
  'fields.selectPlaceholder': 'Seleccionar {label}...',
  'fields.enterPlaceholder': 'Introducir {label}...',
  'fields.optionsLoadError': 'No se pudieron cargar las opciones de {label}',
  'fields.label.requester': 'Solicitante',
  'fields.label.subject': 'Asunto',
  'fields.label.description': 'Descripción',
  'fields.label.status': 'Estado',
  'fields.label.priority': 'Prioridad',
  'fields.label.source': 'Origen',
  'fields.label.ticket_type': 'Tipo',
  'fields.label.agent': 'Agente',
  'fields.label.group': 'Grupo',
  'fields.label.internal_agent': 'Agente interno',
  'fields.label.internal_group': 'Grupo interno',
  'fields.label.company': 'Empresa',
  'editor.defaultPlaceholder': 'Escribe aquí...',
  'editor.ariaLabel': 'Editor de texto enriquecido',
  'editor.toolbarAria': 'Formato de texto',
  'editor.bold': 'Negrita (Ctrl+B)',
  'editor.italic': 'Cursiva (Ctrl+I)',
  'editor.underline': 'Subrayado (Ctrl+U)',
  'editor.strikethrough': 'Tachado',
  'editor.heading1': 'Encabezado 1',
  'editor.heading2': 'Encabezado 2',
  'editor.textColor': 'Color del texto',
  'editor.highlight': 'Resaltar',
  'editor.bulletList': 'Lista con viñetas',
  'editor.numberedList': 'Lista numerada',
  'editor.blockquote': 'Cita',
  'editor.codeBlock': 'Bloque de código',
  'editor.insertLink': 'Insertar enlace',
  'editor.insertImage': 'Insertar imagen',
  'editor.insertTable': 'Insertar tabla',
  'editor.mention': 'Mencionar a alguien',
  'editor.undo': 'Deshacer (Ctrl+Z)',
  'editor.redo': 'Rehacer (Ctrl+Shift+Z)',
  'editor.attach': 'Adjuntar archivo',
  'editor.noAgents': 'No se encontraron agentes',
  'editor.mentionSuggestions': 'Sugerencias de menciones',
  'editor.dialogLinkTitle': 'Insertar enlace',
  'editor.dialogImageTitle': 'Insertar imagen',
  'editor.linkHint': 'Introduce una URL HTTP(S), mailto, ancla o relativa.',
  'editor.imageHint': 'Introduce una URL de imagen HTTP(S) o relativa.',
  'editor.url': 'URL',
  'editor.invalidLink': 'Introduce una URL HTTP(S), mailto, ancla o relativa válida.',
  'editor.invalidImage': 'Introduce una URL de imagen HTTP(S) o relativa válida.',
  'editor.selectTextForLink': 'Selecciona texto antes de añadir un enlace.',
  'editor.imageInsertFailed': 'No se pudo insertar la imagen aquí.',
  'editor.insertLinkAction': 'Insertar enlace',
  'editor.insertImageAction': 'Insertar imagen',
  'search.dialogAria': 'Búsqueda global',
  'search.placeholder': 'Buscar tickets, contactos...',
  'search.aria': 'Buscar',
  'search.close': 'Cerrar búsqueda',
  'search.noMatches': 'Sin coincidencias para «{query}»',
  'search.noMatchesHint': 'Prueba con un número de ticket, un correo de contacto o el nombre de una empresa.',
  'search.hintBefore': 'Escribe al menos 2 caracteres para buscar. Pulsa',
  'search.hintAfter': 'para cerrar.',

  'td.system': 'Sistema',
  'td.actionCreatedTicket': 'creó el ticket',
  'td.actionUpdatedFields': 'actualizó {fields}',
  'td.fieldStatus': 'estado',
  'td.fieldPriority': 'prioridad',
  'td.fieldSource': 'origen',
  'td.fieldType': 'tipo',
  'td.fieldGroup': 'grupo',
  'td.fieldAgent': 'agente',
  'td.fieldCompany': 'empresa',
  'td.fieldContact': 'contacto',
  'td.fieldSubject': 'asunto',
  'td.fieldDescription': 'descripción',
  'td.fieldProduct': 'producto',
  'td.fieldResolutionDue': 'fecha límite de resolución',
  'td.fieldFirstResponseDue': 'fecha límite de primera respuesta',
  'td.fieldTags': 'etiquetas',
  'td.fieldParentTicket': 'ticket principal',
  'td.eventCreated': '{actor} creó un nuevo ticket',
  'td.eventCreatedLinked': '{actor} creó un nuevo ticket y lo vinculó a un ticket principal',
  'td.eventSplit': '{actor} dividió este ticket y creó el ticket secundario{ref}',
  'td.eventMergeReceived': '{actor} fusionó otro ticket en este ticket{ref}',
  'td.eventMerged': '{actor} fusionó este ticket en otro ticket{ref}',
  'td.eventSplitCopied': '{actor} copió {conversations} y {attachments}',
  'td.conversationsOne': '{count} conversación',
  'td.conversationsMany': '{count} conversaciones',
  'td.attachmentsOne': '{count} archivo adjunto',
  'td.attachmentsMany': '{count} archivos adjuntos',
  'td.eventUpdatedFields': '{actor} actualizó {fields}',
  'td.invalidSlaState': 'El servidor devolvió un estado de SLA no válido.',
  'td.slaRefreshError': 'No se pudieron actualizar los relojes de SLA.',
  'td.descriptionUpdated': 'Descripción actualizada',
  'td.descriptionUpdateError': 'No se pudo actualizar la descripción',
  'td.descriptionUpdateFailed': 'Error al actualizar la descripción',
  'td.entryUpdated': 'Entrada actualizada',
  'td.entryUpdateError': 'No se pudo actualizar la entrada',
  'td.updateFailed': 'Error al actualizar',
  'td.loadOlderError': 'No se pudieron cargar las conversaciones anteriores',
  'td.loadFailed': 'Error al cargar',
  'td.slaUpdateFailed': 'Error al actualizar el SLA',
  'td.reasonTooLong': 'El motivo debe tener 500 caracteres o menos.',
  'td.invalidDateTime': 'Elija una fecha y hora válidas.',
  'td.slaDeadlineUpdated': 'Fecha límite de SLA actualizada',
  'td.slaConflict': 'El ticket cambió mientras editaba los datos de SLA. Recargue antes de intentarlo de nuevo.',
  'td.slaClearFailed': 'Error al borrar el SLA',
  'td.slaTargetCleared': 'Objetivo de SLA borrado',
  'td.slaClearError': 'No se pudo borrar el objetivo de SLA',
  'td.noDescription': 'Aún no se ha agregado una descripción.',
  'td.editDescriptionAria': 'Editar la descripción del ticket',
  'td.download': 'Descargar',
  'td.downloadFile': 'Descargar {fileName}',
  'td.loadOlder': '↓ +{count} conversación',
  'td.loadOlderMany': '↓ +{count} conversaciones',
  'td.edited': '(editado)',
  'td.privateThread': 'Hilo privado',
  'td.propertiesAria': 'Propiedades del ticket',
  'td.expandProperties': 'Expandir propiedades',
  'td.collapseProperties': 'Contraer propiedades',
  'td.metric': 'Métrica',
  'td.firstResponseOption': 'Primera respuesta',
  'td.resolutionOption': 'Resolución',
  'td.overrideHint': 'Establezca una fecha límite manual con autoridad del servidor. El motivo se conserva en el historial de SLA.',
  'td.deadline': 'Fecha límite',
  'td.reasonOptional': 'Motivo (opcional)',
  'td.reasonPlaceholder': 'Excepción aprobada o contexto operativo',
  'td.clearResolutionOverride': 'Borrar la fecha de resolución manual',
  'td.clearEscalationTarget': 'Borrar el objetivo de escalación',
  'td.toolsAria': 'Herramientas del ticket y contacto',
  'td.ticketContext': 'Contexto del ticket',
  'td.knowledgeBase': 'Base de conocimiento',
  'td.shortcutsAria': 'Accesos directos del contexto del ticket',
  'td.showContext': 'Mostrar el contexto del ticket',
  'td.hideContext': 'Ocultar el contexto del ticket',
  'td.openRow': 'Abrir {label}',
  'td.editTicket': 'Editar ticket',
  'td.searchContactPlaceholder': 'Buscar contacto…',
  'td.describePlaceholder': 'Describa el problema…',
  'td.noAttachments': 'Sin archivos adjuntos',

  'tp.api.csrfUnavailable': 'No se pudo establecer la protección CSRF',
  'tp.api.noMfaChallenge': 'No hay ningún desafío de MFA activo',
  'tp.api.noMfaSetup': 'No hay ningún desafío de configuración de MFA activo',
  'tp.api.noNewPasswordChallenge': 'No hay ningún desafío de nueva contraseña activo',
  'tp.articles.isLinkedAria': '{title} está vinculado como solución',
  'tp.articles.linkAria': 'Vincular {title} como solución',
  'tp.articles.linkAsSolution': 'Vincular como solución',
  'tp.articles.linkedAsSolution': 'Vinculado como solución',
  'tp.articles.none': 'No hay artículos sugeridos para este ticket.',
  'tp.articles.title': 'Artículos sugeridos',
  'tp.articles.views': '{count} vistas',
  'tp.attachment.loadingPreview': 'Cargando vista previa…',
  'tp.attachment.previewUnavailable': 'Vista previa no disponible',
  'tp.charts.noData': 'No hay datos del gráfico para este periodo.',
  'tp.charts.noRecords': 'No hay registros en este periodo.',
  'tp.charts.period': 'Periodo',
  'tp.charts.showingTop': 'Mostrando los {shown} principales de {total} segmentos.',
  'tp.common.cancel': 'Cancelar',
  'tp.common.clear': 'Borrar',
  'tp.common.loading': 'Cargando…',
  'tp.common.send': 'Enviar',
  'tp.common.sending': 'Enviando…',
  'tp.common.system': 'Sistema',
  'tp.convActions.edit': 'Editar',
  'tp.convActions.thread': 'Iniciar un hilo',
  'tp.dashboard.new': 'Nuevo',
  'tp.dashboard.select': 'Seleccionar panel',
  'tp.forward.failed': 'Error al reenviar',
  'tp.forward.forwarded': 'Ticket reenviado',
  'tp.forward.forwarding': 'Reenviando…',
  'tp.forward.forwardingMany': 'Reenviando {count} conversaciones:',
  'tp.forward.forwardingOne': 'Reenviando 1 conversación:',
  'tp.forward.message': 'Mensaje',
  'tp.forward.messagePlaceholder': 'Agregue un mensaje (opcional)…',
  'tp.forward.noContacts': 'No se encontraron contactos: escriba una dirección de correo completa',
  'tp.forward.recipientEmail': 'Correo del destinatario',
  'tp.forward.recipientInvalid': 'Introduzca una dirección de correo del destinatario válida',
  'tp.forward.recipientRequired': 'El correo del destinatario es obligatorio',
  'tp.forward.searchContact': 'Busque un contacto o escriba un correo…',
  'tp.forward.title': 'Reenviar',
  'tp.forward.to': 'Para',
  'tp.forward.useThisEmail': 'Presione Intro o haga clic en Reenviar para usar este correo',
  'tp.jira.addOptional': 'Agregar campos opcionales',
  'tp.jira.createAndLink': 'Crear y vincular incidencia',
  'tp.jira.createIssue': 'Crear incidencia',
  'tp.jira.createTitle': 'Crear incidencia de Jira',
  'tp.jira.describePlaceholder': 'Describa el problema…',
  'tp.jira.description': 'Descripción',
  'tp.jira.development': 'Desarrollo',
  'tp.jira.enterDevelopment': 'Introduzca el desarrollo',
  'tp.jira.hideOptional': 'Ocultar campos opcionales',
  'tp.jira.issueId': 'ID de incidencia',
  'tp.jira.issueSummary': 'Resumen de la incidencia',
  'tp.jira.issueType': 'Tipo de incidencia *',
  'tp.jira.lastSync': 'Última sincronización: {error}',
  'tp.jira.linkIssue': 'Vincular incidencia',
  'tp.jira.linkTitle': 'Vincular incidencia de Jira',
  'tp.jira.linkedIssues': 'Incidencias vinculadas',
  'tp.jira.linkedIssuesHint': 'Use claves de incidencias de Jira separadas por comas.',
  'tp.jira.linkedIssuesPlaceholder': 'p. ej., SUP-123, SUP-456',
  'tp.jira.loadingFields': 'Cargando campos de Jira…',
  'tp.jira.loadingIssueTypes': 'Cargando tipos de incidencia…',
  'tp.jira.loadingProjects': 'Cargando proyectos de Jira…',
  'tp.jira.loadingUsers': 'Cargando usuarios de Jira…',
  'tp.jira.noLinks': 'Aún no hay incidencias de Jira vinculadas a este ticket.',
  'tp.jira.noneFound': 'No se encontraron incidencias de Jira.',
  'tp.jira.notAvailableProject': 'No disponible para este proyecto',
  'tp.jira.projects': 'Proyectos *',
  'tp.jira.refresh': 'Actualizar',
  'tp.jira.refreshFields': 'Actualizar campos de Jira',
  'tp.jira.reporter': 'Informador',
  'tp.jira.requestFailed': 'La solicitud a Jira falló. Inténtelo de nuevo.',
  'tp.jira.searchBy': 'Buscar por:',
  'tp.jira.searchIssue': 'Buscar incidencia',
  'tp.jira.searchIssuePlaceholder': 'Buscar incidencia…',
  'tp.jira.searchUsers': 'Buscar usuarios de Jira',
  'tp.jira.searching': 'Buscando en Jira…',
  'tp.jira.selectIssueType': 'Seleccione un tipo de incidencia',
  'tp.jira.selectProject': 'Seleccione un proyecto',
  'tp.jira.summary': 'Resumen *',
  'tp.jira.syncOff': 'Sincronización desactivada',
  'tp.jira.syncOn': 'Sincronización activada',
  'tp.jira.syncStatus': 'Sincronizar el estado del ticket con Jira',
  'tp.jira.unassigned': 'Sin asignar',
  'tp.jira.unlink': 'Desvincular',
  'tp.jira.unlinkConfirm': 'Desvincular incidencia',
  'tp.jira.unlinkDescription': 'Esto elimina la conexión con el ticket, pero no elimina la incidencia de Jira.',
  'tp.jira.unlinkTitle': '¿Desvincular {key}?',
  'tp.jira.untitled': 'Incidencia de Jira sin título',
  'tp.layout.loadingPage': 'Cargando página…',
  'tp.notFound.goToDashboard': 'Ir al panel',
  'tp.notFound.title': 'Página no encontrada',
  'tp.portal.brand': 'Soporte SuzukiDesk',
  'tp.portal.customer': 'Cliente',
  'tp.reply.addNote': 'Agregar nota',
  'tp.reply.attachmentNotAdded': 'Archivo adjunto no agregado',
  'tp.reply.clickToExpand': 'Haga clic para expandir',
  'tp.reply.collapsedNote': 'Agregue una nota interna…',
  'tp.reply.collapsedReply': 'Escriba una respuesta o nota…',
  'tp.reply.conversationType': 'Tipo de conversación',
  'tp.reply.failedToSend': 'Error al enviar',
  'tp.reply.markNoteAs': 'Marcar la nota como',
  'tp.reply.notVisibleToContact': 'No visible para el contacto',
  'tp.reply.notVisibleToContacts': 'No visible para los contactos',
  'tp.reply.noteAdded': 'Nota agregada',
  'tp.reply.notifyTo': 'Notificar a',
  'tp.reply.placeholderPrivateNote': 'Agregue una nota privada...',
  'tp.reply.placeholderPublicNote': 'Agregue una nota pública visible para el solicitante...',
  'tp.reply.placeholderReply': 'Escriba su respuesta...',
  'tp.reply.private': 'Privada',
  'tp.reply.public': 'Pública',
  'tp.reply.removeFile': 'Quitar {name}',
  'tp.reply.replySent': 'Respuesta enviada',
  'tp.reply.searchAgentsToNotify': 'Busque agentes a quienes notificar…',
  'tp.reply.sendReply': 'Enviar respuesta',
  'tp.reply.sending': 'Enviando...',
  'tp.reply.tabNote': 'Nota',
  'tp.reply.tabReply': 'Respuesta',
  'tp.reply.uploadAttachment': 'Subir archivo adjunto',
  'tp.reply.visibleToContact': 'Visible para el contacto',
  'tp.reply.visibleToContacts': 'Visible para los contactos',
  'tp.sla.breached': 'Incumplido',
  'tp.sla.cleared': 'Borrado',
  'tp.sla.configErrorNoDeadline': 'Error de configuración de SLA. No se está infiriendo ninguna fecha límite.',
  'tp.sla.configurationError': 'Error de configuración',
  'tp.sla.couldNotLoad': 'No se pudieron cargar los relojes de SLA',
  'tp.sla.done': 'Listo',
  'tp.sla.dueIn': 'Vence en {duration}',
  'tp.sla.dueLine': 'Vence: {date}',
  'tp.sla.dueNow': 'Vence ahora',
  'tp.sla.escalated': 'Escalado',
  'tp.sla.firstResponse': 'Primera respuesta',
  'tp.sla.invalidDeadline': 'Fecha límite no válida',
  'tp.sla.mayBeStale': 'Los relojes de SLA pueden estar desactualizados',
  'tp.sla.noActiveCycle': 'No hay ningún ciclo de SLA activo.',
  'tp.sla.noDeadline': 'Sin fecha límite',
  'tp.sla.noMetrics': 'No hay métricas de SLA disponibles para este ciclo.',
  'tp.sla.noPolicy': 'No se aplicó ninguna política de SLA a este ticket.',
  'tp.sla.notConfigured': 'No configurado',
  'tp.sla.notStarted': 'No iniciado',
  'tp.sla.overdueBy': 'Vencido hace {duration}',
  'tp.sla.overridden': 'Modificado manualmente',
  'tp.sla.overrideReason': 'Motivo de la modificación: {reason}',
  'tp.sla.paused': 'En pausa',
  'tp.sla.refreshing': 'Actualizando los relojes de SLA autorizados…',
  'tp.sla.resolution': 'Resolución',
  'tp.sla.stopsSla': 'Detiene el SLA',
  'tp.thread.empty': 'Aún no se ha enviado nada. Su primer mensaje iniciará este hilo privado.',
  'tp.thread.messageFailed': 'Error en el mensaje',
  'tp.thread.privateThread': 'Hilo privado',
  'tp.thread.replyPlaceholder': 'Responder en el hilo…',
  'tp.thread.someone': 'Alguien',
  'tp.thread.startPrivateThread': 'Iniciar un hilo privado',
  'tp.thread.startedBy': '{name} inició este hilo',
  'tp.thread.unableToSend': 'No se pudo enviar el mensaje',
  'tp.ui.breadcrumb': 'Ruta de navegación',
  'tp.ui.closePanel': 'Cerrar panel',
  'tp.ui.dismiss': 'Descartar {title}',

  'dir.loadError': 'No se pudieron cargar los datos. Inténtelo de nuevo.',
  'dir.contacts.description': 'Contactos de clientes y su historial de soporte.',
  'dir.contacts.searchAria': 'Buscar contactos',
  'dir.contacts.count': '{count} contactos',
  'dir.contacts.noMatch': 'Ningún contacto coincide con esta búsqueda',
  'dir.contacts.none': 'Aún no hay contactos',
  'dir.contacts.noneDescription': 'Los contactos aparecerán aquí cuando los clientes empiecen a enviar tickets.',
  'dir.company': 'Empresa',
  'dir.unnamedContact': 'Contacto sin nombre',
  'dir.contact': 'Contacto',
  'dir.contactNotFound': 'Contacto no encontrado.',
  'dir.confirmDeleteContactTitle': '¿Eliminar «{name}»?',
  'dir.thisContact': 'este contacto',
  'dir.confirmDeleteContactDescription': 'Los contactos con tickets se desactivarán en lugar de eliminarse de forma permanente.',
  'dir.deleteContact': 'Eliminar contacto',
  'dir.editProfile': 'Editar perfil',
  'dir.profile': 'Perfil',
  'dir.firstName': 'Nombre',
  'dir.lastName': 'Apellidos',
  'dir.phone': 'Teléfono',
  'dir.timezone': 'Zona horaria',
  'dir.emailLabel': 'Correo:',
  'dir.phoneLabel': 'Teléfono:',
  'dir.companyLabel': 'Empresa:',
  'dir.timezoneLabel': 'Zona horaria:',
  'dir.recentTickets': 'Tickets recientes',
  'dir.noTicketsYet': 'Aún no hay tickets',
  'dir.contactTicketsDescription': 'Los tickets creados por este contacto se mostrarán aquí.',
  'dir.ticket': 'Ticket',
  'dir.subject': 'Asunto',
  'dir.status': 'Estado',
  'dir.created': 'Creado',
  'dir.companies.description': 'Organizaciones vinculadas a contactos de clientes y tickets.',
  'dir.companies.add': 'Agregar empresa',
  'dir.companies.domain': 'Dominio',
  'dir.companies.create': 'Crear empresa',
  'dir.companies.searchAria': 'Buscar empresas',
  'dir.companies.searchPlaceholder': 'Buscar empresas o dominios',
  'dir.companies.noMatch': 'Ninguna empresa coincide con esta búsqueda',
  'dir.companies.addFirst': 'Agregue su primera empresa',
  'dir.companies.tryDifferent': 'Pruebe con otro nombre de empresa o dominio.',
  'dir.companies.useForm': 'Use el formulario junto a esta lista para crear una empresa.',
  'dir.companies.contacts': 'Contactos',
  'dir.companies.tickets': 'Tickets',
  'dir.companies.notFound': 'Empresa no encontrada.',
  'dir.companies.confirmDeleteTitle': '¿Eliminar «{name}»?',
  'dir.companies.thisCompany': 'esta empresa',
  'dir.companies.confirmDeleteDescription': 'La empresa no debe tener contactos ni tickets para poder eliminarla.',
  'dir.companies.delete': 'Eliminar empresa',
  'dir.companies.noDomain': 'Sin dominio configurado',
  'dir.companies.contactsCount': 'Contactos ({count})',
  'dir.companies.ticketsCount': 'Tickets ({count})',
  'dir.companies.noContactsDescription': 'Agregue un contacto y vincúlelo a esta empresa para verlo aquí.',
  'dir.companies.noTicketsDescription': 'Los tickets creados por los contactos de esta empresa se mostrarán aquí.',
  'dir.trendsCreatedHour': 'Fecha de creación - Hora del día',
  'dir.reports.loadError': 'No se pudo cargar este informe. Inténtelo de nuevo.',
  'dir.reports.volume': 'Volumen de tickets',
  'dir.reports.sla': 'Cumplimiento de SLA',
  'dir.reports.agents': 'Desempeño de agentes',
  'dir.reports.csat': 'Satisfacción del cliente',
  'dir.reports.rca': 'Análisis de causa raíz',
  'dir.reports.descVolume': 'Vea de dónde provienen los tickets y cómo avanzan en su ciclo de vida.',
  'dir.reports.descSla': 'Dé seguimiento a los objetivos de respuesta y resolución en toda la operación de soporte accesible.',
  'dir.reports.descAgents': 'Compare la carga de trabajo, los resultados, las respuestas y los tiempos promedio de atención por agente.',
  'dir.reports.descCsat': 'Conozca la opinión de los clientes sin confundir el volumen de respuestas con la tasa de satisfacción.',
  'dir.reports.descRca': 'Encuentre las causas raíz estandarizadas detrás de la demanda de tickets.',
  'dir.reports.noPayload': 'No se devolvieron datos del informe para este periodo.',
  'dir.reports.refresh': 'Actualizar',
  'dir.reports.report': 'Informe',
  'dir.reports.from': 'Desde',
  'dir.reports.to': 'Hasta',
  'dir.reports.maxRange': 'Rango máximo: 90 días · el alcance depende de los permisos de su cuenta.',
  'dir.reports.unclassified': 'Sin clasificar',
  'dir.reports.ticketsInPeriod': 'Tickets en el periodo',
  'dir.reports.ticketsInPeriodDetail': 'Tickets accesibles devueltos por el informe',
  'dir.reports.created': 'Creados',
  'dir.reports.createdDetail': 'En el eje de fechas seleccionado',
  'dir.reports.resolved': 'Resueltos',
  'dir.reports.resolvedDetail': '{percent}% del volumen creado',
  'dir.reports.noCreated': 'No hay tickets creados',
  'dir.reports.reopened': 'Reabiertos',
  'dir.reports.reopenedDetail': 'Eventos del ciclo de vida, no tickets únicos',
  'dir.reports.dailyPulse': 'Pulso diario',
  'dir.reports.volumeByDate': 'Volumen de tickets por fecha',
  'dir.reports.volumeByDateDescription': 'Las filas dispersas del backend se expanden a un eje de fechas completo rellenado con ceros.',
  'dir.reports.createdTickets': 'Tickets creados',
  'dir.reports.createdVolumeAria': 'Volumen de tickets creados por fecha',
  'dir.reports.lifecycle': 'Ciclo de vida',
  'dir.reports.lifecycleTitle': 'Creados, resueltos, reabiertos',
  'dir.reports.lifecycleDescription': 'Una vista de tres líneas del movimiento a través del ciclo de vida del ticket.',
  'dir.reports.lifecycleAria': 'Eventos del ciclo de vida de los tickets por fecha',
  'dir.reports.dimensions': 'Dimensiones',
  'dir.reports.whereConcentrated': 'Dónde se concentra el volumen',
  'dir.reports.topEight': 'Se muestran los ocho segmentos principales por panel',
  'dir.reports.status': 'Estado',
  'dir.reports.statusDescription': 'Estado actual del ticket',
  'dir.reports.priority': 'Prioridad',
  'dir.reports.priorityDescription': 'Distribución de prioridades de tickets',
  'dir.reports.group': 'Grupo',
  'dir.reports.groupDescription': 'Grupos de enrutamiento',
  'dir.reports.agent': 'Agente',
  'dir.reports.agentDescription': 'Responsabilidad asignada',
  'dir.reports.product': 'Producto',
  'dir.reports.productDescription': 'Distribución de productos',
  'dir.reports.country': 'País',
  'dir.reports.countryDescription': 'De los campos de país estandarizados',
  'dir.reports.noRecords': 'No hay registros en este periodo.',
  'dir.reports.slaSummary': '{rate} · {met} de {total} cumplidos',
  'dir.reports.noSlaSegments': 'Aún no hay segmentos de SLA',
  'dir.reports.noSlaSegmentsDescription': 'No hay registros de SLA aplicables para esta dimensión en el periodo seleccionado.',
  'dir.reports.segment': 'Segmento',
  'dir.reports.firstResponse': 'Primera respuesta',
  'dir.reports.resolution': 'Resolución',
  'dir.reports.avgFirstResponse': 'Prom. primera respuesta',
  'dir.reports.avgResolution': 'Prom. resolución',
  'dir.reports.fromTicketMetric': 'De TicketMetric',
  'dir.reports.slaLens': 'Vista de SLA',
  'dir.reports.performanceBySegment': 'Desempeño por segmento',
  'dir.reports.slaRatesNote': 'Las tasas usan solo los registros con un objetivo de SLA aplicable. Las duraciones son el tiempo transcurrido promedio.',
  'dir.reports.slaDimensionAria': 'Dimensión del desglose de SLA',
  'dir.reports.rosterSignal': 'Señal del equipo',
  'dir.reports.agentPerformance': 'Desempeño de agentes',
  'dir.reports.agentPerformanceDescription': 'Se incluyen todos los agentes activos, incluso aquellos sin actividad.',
  'dir.reports.filterAgentsAria': 'Filtrar agentes',
  'dir.reports.filterAgentsPlaceholder': 'Filtrar por agente o correo',
  'dir.reports.matchingAgents': '{count} agentes coincidentes',
  'dir.reports.activeAgents': '{count} agentes activos',
  'dir.reports.sortedBy': 'ordenado por {key} {direction}',
  'dir.reports.asc': 'ascendente',
  'dir.reports.desc': 'descendente',
  'dir.reports.noAgentsMatch': 'Ningún agente coincide con este filtro',
  'dir.reports.assigned': 'Asignados',
  'dir.reports.replies': 'Respuestas',
  'dir.reports.csatScore': 'Puntuación CSAT',
  'dir.reports.csatScoreDetail': 'Calificaciones de 4 o 5',
  'dir.reports.averageRating': 'Calificación promedio',
  'dir.reports.averageRatingDetail': 'En las encuestas calificadas',
  'dir.reports.ratedSurveys': 'Encuestas calificadas',
  'dir.reports.ratedSurveysDetail': 'En el periodo seleccionado',
  'dir.reports.satisfied': 'Satisfechos',
  'dir.reports.satisfiedDetail': 'Respuestas positivas',
  'dir.reports.responseTrend': 'Tendencia de respuestas',
  'dir.reports.surveyVolume': 'Volumen de encuestas por fecha',
  'dir.reports.surveyVolumeDescription': 'El backend devuelve el número de respuestas por fecha; no es una puntuación diaria. Abajo se muestran las últimas 100 respuestas como muestra.',
  'dir.reports.surveyResponses': 'Respuestas de encuestas',
  'dir.reports.surveyVolumeAria': 'Volumen de respuestas de encuestas CSAT por fecha',
  'dir.reports.responsesByGroup': 'Respuestas por grupo',
  'dir.reports.responsesByGroupDescription': 'Número de respuestas de encuestas, no una tasa de satisfacción del grupo',
  'dir.reports.responsesByAgent': 'Respuestas por agente',
  'dir.reports.responsesByAgentDescription': 'Número de respuestas de encuestas, no una tasa de satisfacción del agente',
  'dir.reports.customerVoice': 'Voz del cliente',
  'dir.reports.latestSurveys': 'Últimas respuestas de encuestas',
  'dir.reports.boundedSample': 'Muestra limitada · {count} de un máximo de 100',
  'dir.reports.latestSurveysNote': 'Las respuestas más recientes devueltas por la API de informes. Use esta tabla para una lectura rápida, no como exportación completa.',
  'dir.reports.noSurveys': 'No hay respuestas de encuestas',
  'dir.reports.noSurveysDescription': 'Las respuestas de CSAT aparecerán aquí cuando los clientes califiquen un ticket resuelto.',
  'dir.reports.rating': 'Calificación',
  'dir.reports.comment': 'Comentario',
  'dir.reports.received': 'Recibido',
  'dir.reports.ratingOutOf': '{rating} de 5',
  'dir.reports.noComment': 'Sin comentario',
  'dir.reports.rcaEyebrow': 'Análisis de causa raíz',
  'dir.reports.rcaTitle': 'Por qué se crean tickets',
  'dir.reports.rcaDescription': 'La categoría y la subcategoría son agregados independientes de los campos personalizados estandarizados del ticket.',
  'dir.reports.rcaDimensionAria': 'Dimensión de RCA',
  'dir.reports.category': 'Categoría',
  'dir.reports.subcategory': 'Subcategoría',
  'dir.reports.rcaEmpty': 'No se registraron valores de causa raíz para este periodo.',
  'dir.kb.articleLoadError': 'No se pudo cargar el artículo.',
  'dir.kb.articleNotFound': 'Artículo no encontrado.',
  'dir.kb.retry': 'Reintentar',
  'dir.kb.title': 'Base de conocimiento',
  'dir.kb.breadcrumb': 'Base de conocimiento',
  'dir.kb.description': '{articles} artículos en {folders} carpetas',
  'dir.kb.newArticle': 'Nuevo artículo',
  'dir.kb.editArticle': 'Editar artículo',
  'dir.kb.sectionsAria': 'Secciones de la base de conocimiento',
  'dir.kb.tabArticles': 'Artículos',
  'dir.kb.tabStructure': 'Categorías y carpetas',
  'dir.kb.folderFilterAria': 'Filtro de carpeta',
  'dir.kb.allArticles': 'Todos los artículos ({count})',
  'dir.kb.writeFirst': 'Escriba su primer artículo',
  'dir.kb.writeFirstDescription': 'Use Nuevo artículo para agregar contenido a esta carpeta.',
  'dir.kb.byAuthor': 'por {name}',
  'dir.kb.views': '{count} vistas',
  'dir.kb.published': 'Publicado',
  'dir.kb.draft': 'Borrador',
  'dir.kb.publish': 'Publicar',
  'dir.kb.unpublish': 'Anular publicación',
  'dir.kb.noFolders': 'No hay carpetas en esta categoría',
  'dir.kb.noFoldersDescription': 'Agregue una carpeta para empezar a agrupar artículos.',
  'dir.kb.articlesCount': '{count} artículos',
  'dir.kb.fieldTitle': 'Título',
  'dir.kb.folder': 'Carpeta',
  'dir.kb.selectFolder': 'Seleccionar carpeta',
  'dir.kb.content': 'Contenido',
  'dir.kb.contentPlaceholder': 'Escriba el contenido de su artículo...',
  'dir.kb.tags': 'Etiquetas (separadas por comas)',
  'dir.kb.attachments': 'Archivos adjuntos',
  'dir.kb.download': 'Descargar',
  'dir.kb.downloadFile': 'Descargar {name}',
  'dir.kb.remove': 'Quitar',
  'dir.kb.removeFile': 'Quitar {name}',
  'dir.kb.noAttachments': 'Aún no hay archivos adjuntos.',
  'dir.kb.uploadAria': 'Subir archivo adjunto',
  'dir.kb.uploading': 'Subiendo...',
  'dir.kb.addFile': 'Agregar archivo',
  'dir.kb.confirmDeleteTitle': '¿Eliminar el artículo?',
  'dir.kb.confirmDeleteDescription': 'Este artículo, publicado o en borrador, se eliminará de forma permanente.',
  'dir.kb.confirmDeleteLabel': 'Eliminar artículo',
  'dir.kb.confirmRemoveTitle': '¿Quitar el archivo adjunto?',
  'dir.kb.confirmRemoveDescription': 'El archivo se quitará de este artículo de forma permanente.',
  'dir.kb.confirmRemoveLabel': 'Quitar archivo adjunto',
  'dir.reports.rangeInvalid': 'Elija fechas de inicio y fin válidas.',
  'dir.reports.rangeOrder': 'La fecha de fin debe ser igual o posterior a la de inicio.',
  'dir.reports.rangeMax': 'Los informes admiten un rango de fechas máximo de 90 días.',

  'adm.active': 'Activo',
  'adm.auto.action.add_tag': 'agregar etiqueta',
  'adm.auto.action.assign_agent': 'asignar agente',
  'adm.auto.action.assign_group': 'asignar grupo',
  'adm.auto.action.send_email': 'enviar correo',
  'adm.auto.action.send_notification': 'enviar notificación',
  'adm.auto.action.set_priority': 'establecer prioridad',
  'adm.auto.action.set_status': 'establecer estado',
  'adm.auto.actions': 'Acciones',
  'adm.auto.addAction': '+ Agregar acción',
  'adm.auto.addCondition': '+ Agregar condición',
  'adm.auto.addRule': 'Agregar regla',
  'adm.auto.colApplied': 'Acciones aplicadas',
  'adm.auto.colDate': 'Fecha',
  'adm.auto.colMatched': 'Coincidió',
  'adm.auto.colSubject': 'Asunto',
  'adm.auto.colTicket': 'Ticket',
  'adm.auto.conditions': 'Condiciones',
  'adm.auto.confirmDesc': 'Esta regla dejará de ejecutarse de inmediato y no se podrá restaurar.',
  'adm.auto.confirmLabel': 'Eliminar regla',
  'adm.auto.confirmTitle': '¿Eliminar la regla de automatización?',
  'adm.auto.countMany': '{count} reglas de automatización',
  'adm.auto.countOne': '{count} regla de automatización',
  'adm.auto.create': 'Crear',
  'adm.auto.createFirst': 'Cree su primera regla de automatización',
  'adm.auto.createFirstDesc': 'Use Agregar regla para enrutar, priorizar o notificar automáticamente.',
  'adm.auto.deleteFailed': 'Error al eliminar',
  'adm.auto.description': 'Las reglas se ejecutan en secuencia según su posición. Las condiciones de una regla se combinan con Y.',
  'adm.auto.editRule': 'Editar regla de automatización',
  'adm.auto.execFailed': 'No se pudieron cargar las ejecuciones',
  'adm.auto.field.assigneeId': 'responsable',
  'adm.auto.field.companyId': 'empresa',
  'adm.auto.field.groupId': 'grupo',
  'adm.auto.field.priority': 'prioridad',
  'adm.auto.field.requesterId': 'solicitante',
  'adm.auto.field.source': 'origen',
  'adm.auto.field.status': 'estado',
  'adm.auto.field.subject': 'asunto',
  'adm.auto.field.ticketTypeId': 'tipo de ticket',
  'adm.auto.hits': 'Coincidencias',
  'adm.auto.loadFailed': 'No se pudieron cargar las reglas de automatización',
  'adm.auto.log': 'Registro',
  'adm.auto.logTitle': 'Registro de ejecución — {name}',
  'adm.auto.moveDown': 'Mover hacia abajo',
  'adm.auto.moveUp': 'Mover hacia arriba',
  'adm.auto.newRule': 'Nueva regla de automatización',
  'adm.auto.no': 'No',
  'adm.auto.noRuns': 'Aún no hay ejecuciones registradas',
  'adm.auto.noRunsDesc': 'Las ejecuciones aparecerán aquí la primera vez que esta regla coincida con un ticket.',
  'adm.auto.op.contains': 'contiene',
  'adm.auto.op.ends_with': 'termina con',
  'adm.auto.op.greater_than': 'mayor que',
  'adm.auto.op.in': 'está en',
  'adm.auto.op.is': 'es',
  'adm.auto.op.is_empty': 'está vacío',
  'adm.auto.op.is_not': 'no es',
  'adm.auto.op.is_not_empty': 'no está vacío',
  'adm.auto.op.less_than': 'menor que',
  'adm.auto.op.not_contains': 'no contiene',
  'adm.auto.op.not_in': 'no está en',
  'adm.auto.op.starts_with': 'empieza con',
  'adm.auto.reorderFailed': 'Error al reordenar',
  'adm.auto.saveFailed': 'Error al guardar',
  'adm.auto.stopProcessing': 'Detener el procesamiento de las reglas siguientes',
  'adm.auto.title': 'Reglas de automatización',
  'adm.auto.toggleFailed': 'Error al cambiar el estado',
  'adm.auto.trigger': 'Disparador *',
  'adm.auto.trigger.ticket_creation': 'Creación de ticket',
  'adm.auto.trigger.ticket_update': 'Actualización de ticket',
  'adm.auto.trigger.time_trigger': 'Basado en tiempo',
  'adm.auto.triggerCol': 'Disparador',
  'adm.auto.valuePlaceholder': 'Valor',
  'adm.auto.yes': 'Sí',
  'adm.close': 'Cerrar',
  'adm.deleting': 'Eliminando...',
  'adm.description': 'Descripción',
  'adm.descriptionLabel': 'Descripción',
  'adm.edit': 'Editar',
  'adm.email.addChannel': 'Agregar canal',
  'adm.email.addTitle': 'Agregar canal de correo',
  'adm.email.colEmail': 'Correo',
  'adm.email.colReplyTo': 'Responder a',
  'adm.email.colSmtp': 'SMTP',
  'adm.email.confirmDesc': 'Este canal ya no estará disponible para el correo de soporte.',
  'adm.email.confirmLabel': 'Eliminar canal',
  'adm.email.confirmTitle': '¿Eliminar el canal de correo?',
  'adm.email.countMany': '{count} canales de correo',
  'adm.email.countOne': '{count} canal de correo',
  'adm.email.create': 'Crear',
  'adm.email.createFirst': 'Agregue su primer canal de correo',
  'adm.email.createFirstDesc': 'Use Agregar canal para conectar una dirección de soporte y que las respuestas lleguen a este centro.',
  'adm.email.default': 'Predeterminado',
  'adm.email.defaultChannel': 'Canal predeterminado',
  'adm.email.deleteFailed': 'Error al eliminar',
  'adm.email.description': 'Administre las direcciones de correo entrantes y salientes, la configuración SMTP y los ajustes de respuesta.',
  'adm.email.editTitle': 'Editar canal de correo',
  'adm.email.emailAddress': 'Dirección de correo *',
  'adm.email.loadFailed': 'No se pudieron cargar las configuraciones de correo',
  'adm.email.outbound': 'SMTP saliente',
  'adm.email.replyTo': 'Dirección de respuesta',
  'adm.email.replyToPh': '(por defecto, la dirección de correo)',
  'adm.email.saveFailed': 'Error al guardar',
  'adm.email.sesGlobal': 'SES (global)',
  'adm.email.smtpHost': 'Host SMTP',
  'adm.email.smtpHostPh': 'p. ej., email-smtp.eu-central-1.amazonaws.com',
  'adm.email.smtpPassword': 'Contraseña SMTP',
  'adm.email.smtpPort': 'Puerto SMTP',
  'adm.email.smtpUser': 'Usuario SMTP',
  'adm.email.title': 'Canales de correo',
  'adm.groups.aboutBody': 'Los miembros determinan qué agentes ven de forma predeterminada los tickets de este grupo. El horario laboral rige los tiempos de SLA de los tickets enrutados aquí, y el contacto de escalación recibe una notificación además del responsable cuando un ticket incumple su SLA.',
  'adm.groups.aboutTitle': 'Acerca de este grupo',
  'adm.groups.accountDefault': 'Predeterminado de la cuenta',
  'adm.groups.activeAgentMany': '{count} agentes activos',
  'adm.groups.activeAgentOne': '{count} agente activo',
  'adm.groups.activeAgents': 'Agentes activos',
  'adm.groups.addMember': 'Agregar miembro',
  'adm.groups.assignment': 'Asignación',
  'adm.groups.autoAssign': 'Asignación automática',
  'adm.groups.autoAssignNote': 'En este producto la asignación de tickets siempre es manual: no hay enrutamiento por turnos ni por carga. Este interruptor no lo cambia.',
  'adm.groups.businessHours': 'Horario laboral',
  'adm.groups.colGroup': 'Grupo',
  'adm.groups.confirmDesc': 'Primero hay que reasignar los tickets y las plantillas que usan este grupo.',
  'adm.groups.confirmLabel': 'Eliminar grupo',
  'adm.groups.confirmTitle': '¿Eliminar «{name}»?',
  'adm.groups.createFirst': 'Cree su primer grupo',
  'adm.groups.defaultHours': 'Horario predeterminado',
  'adm.groups.editAria': 'Editar {name}',
  'adm.groups.editGroup': 'Editar grupo',
  'adm.groups.escalateHelp': 'Se agrega como destinatario de notificaciones cuando un ticket de este grupo incumple su SLA.',
  'adm.groups.escalateTo': 'Escalar a',
  'adm.groups.escalatesTo': 'Escala a',
  'adm.groups.escalatesToName': 'Escala a {name}',
  'adm.groups.escalationBody': 'Cuando un ticket de este grupo incumple su SLA, el contacto de escalación se agrega como destinatario de notificaciones junto con el responsable y los miembros del grupo.',
  'adm.groups.escalationTitle': 'Contacto de escalación',
  'adm.groups.hoursHelp': 'Se usa para los cálculos de SLA de los tickets de este grupo.',
  'adm.groups.manageAgents': 'Gestionar agentes',
  'adm.groups.manageHours': 'Gestionar horario laboral',
  'adm.groups.manual': 'Manual',
  'adm.groups.manualBody': 'En este producto la asignación es manual: no hay asignación automática por turnos ni por carga. El interruptor «Asignación automática» de un grupo solo afecta si los tickets nuevos de ese grupo quedan sin asignar de forma predeterminada o recurren a una regla de enrutamiento existente; los agentes siguen tomando y transfiriendo los tickets por sí mismos.',
  'adm.groups.manualTitle': 'Asignación manual',
  'adm.groups.memberMany': '{count} miembros',
  'adm.groups.memberOne': '{count} miembro',
  'adm.groups.members': 'Miembros',
  'adm.groups.newGroup': 'Nuevo grupo',
  'adm.groups.noEscalation': 'Sin contacto de escalación',
  'adm.groups.noMatch': 'Ningún grupo coincide con esta búsqueda',
  'adm.groups.noMembers': 'Aún no hay miembros',
  'adm.groups.noMembersDesc': 'Elija un agente activo arriba y seleccione Agregar miembro.',
  'adm.groups.remove': 'Quitar',
  'adm.groups.routing': 'Enrutamiento',
  'adm.groups.routingMethod': 'Método de enrutamiento',
  'adm.groups.saved': 'Grupo guardado.',
  'adm.groups.searchAria': 'Buscar grupos',
  'adm.groups.searchPlaceholder': 'Buscar por nombre',
  'adm.groups.selectActiveAgent': 'Seleccionar agente activo',
  'adm.groups.showing': 'Mostrando {start}-{end} de {total}',
  'adm.groups.subtitle': 'Los grupos controlan el enrutamiento y la visibilidad de los tickets. Asigne agentes como miembros y elija un horario laboral y un contacto de escalación para cada grupo.',
  'adm.groups.title': 'Grupos',
  'adm.groups.tryDifferent': 'Pruebe con otro nombre de grupo.',
  'adm.groups.unassigned': 'Sin asignar',
  'adm.groups.useNew': 'Use Nuevo grupo para enrutar tickets a un conjunto de agentes.',
  'adm.groups.zero': '0 grupos',
  'adm.inactive': 'Inactivo',
  'adm.jira.accepted': 'Conexión aceptada',
  'adm.jira.accountEmail': 'Correo de la cuenta de Jira',
  'adm.jira.accountEmailLabel': 'Correo de la cuenta',
  'adm.jira.activeConn': 'Conexión activa',
  'adm.jira.addConnection': 'Agregar conexión',
  'adm.jira.addTitle': 'Agregar conexión de Jira',
  'adm.jira.added': 'Conexión de Jira agregada',
  'adm.jira.apiToken': 'Token de API',
  'adm.jira.clearSecret': 'Borrar el secreto de webhook guardado',
  'adm.jira.confirmDesc': 'Esto elimina la conexión guardada y sus vínculos con tickets. Las incidencias de Jira no se eliminan.',
  'adm.jira.confirmLabel': 'Eliminar conexión',
  'adm.jira.confirmTitle': '¿Eliminar {name}?',
  'adm.jira.connName': 'Nombre de la conexión',
  'adm.jira.connNamePh': 'Jira de Ingeniería',
  'adm.jira.connectedAs': 'Conectado como {name}',
  'adm.jira.connectionDesk': 'Panel de conexiones',
  'adm.jira.default': 'Predeterminada',
  'adm.jira.defaultConn': 'Conexión predeterminada',
  'adm.jira.defaultIssueType': 'Tipo de incidencia predeterminado',
  'adm.jira.defaultProjectKey': 'Clave de proyecto predeterminada',
  'adm.jira.defaults': 'Valores predeterminados',
  'adm.jira.description': 'Conecte sitios de Jira propiedad de la cuenta para que los agentes puedan vincular incidencias y mantener sincronizado el estado de los tickets.',
  'adm.jira.editTitle': 'Editar conexión de Jira',
  'adm.jira.footer': 'Cree el webhook de Jira con el endpoint indicado arriba, suscríbase a los eventos de incidencia actualizada y use el mismo secreto de webhook configurado aquí.',
  'adm.jira.heading': 'Mantenga a soporte e ingeniería en el mismo circuito',
  'adm.jira.intro': 'Las credenciales se almacenan cifradas en el servidor y nunca se devuelven a esta pantalla. Configure un secreto de webhook cuando Jira deba enviar los cambios de estado de vuelta a SuzukiDesk.',
  'adm.jira.no': 'No',
  'adm.jira.noConns': 'Aún no hay conexiones de Jira',
  'adm.jira.noConnsDesc': 'Agregue una conexión para habilitar las acciones de Jira desde el detalle del ticket.',
  'adm.jira.noProject': 'Sin proyecto',
  'adm.jira.pasteToken': 'Pegar token',
  'adm.jira.requestFailed': 'La solicitud a Jira falló. Inténtelo de nuevo.',
  'adm.jira.savedToast': 'Conexión de Jira guardada',
  'adm.jira.secretConfigured': 'Secreto configurado: {value}',
  'adm.jira.secretHint': 'Use el mismo secreto al crear el webhook de Jira.',
  'adm.jira.secretOptional': 'Opcional, 16 caracteres o más',
  'adm.jira.siteUrl': 'URL del sitio de Jira',
  'adm.jira.siteUrlHint': 'No incluya credenciales en la URL.',
  'adm.jira.syncFromJira': 'Estado de Jira al ticket',
  'adm.jira.syncSnapshot': 'Instantánea de la incidencia vinculada',
  'adm.jira.syncToJira': 'Estado del ticket a Jira',
  'adm.jira.testConnection': 'Probar conexión',
  'adm.jira.testFailed': 'Error en la prueba de conexión',
  'adm.jira.title': 'Integración con Jira',
  'adm.jira.tokenHintEdit': 'Déjelo en blanco para conservar el token actual.',
  'adm.jira.tokenHintNew': 'Se almacena cifrado; no se volverá a mostrar.',
  'adm.jira.tokenMissing': 'Falta el token de API',
  'adm.jira.tokenStored': 'Token de API almacenado',
  'adm.jira.unchanged': '(sin cambios si está en blanco)',
  'adm.jira.verified': 'Conexión de Jira verificada',
  'adm.jira.webhookEndpoint': 'Endpoint del webhook de Jira',
  'adm.jira.webhookSecret': 'Secreto del webhook',
  'adm.jira.whatSyncs': 'Qué se sincroniza',
  'adm.jira.yes': 'Sí',
  'adm.nameRequired': 'Nombre *',
  'adm.nextPage': 'Página siguiente',
  'adm.notif.aud.all': 'Compartida',
  'adm.notif.aud.customer': 'Cliente',
  'adm.notif.aud.internal': 'Interna',
  'adm.notif.audEmail': 'Correo {audience}',
  'adm.notif.body': 'Cuerpo',
  'adm.notif.description': 'Personalice cada audiencia de notificaciones sin enviar a los clientes al espacio de trabajo interno.',
  'adm.notif.discardDesc': 'Si cambia de plantilla, perderá los cambios sin guardar de esta plantilla de notificación.',
  'adm.notif.discardLabel': 'Descartar cambios',
  'adm.notif.discardTitle': '¿Descartar los cambios sin guardar?',
  'adm.notif.discarded': 'Cambios sin guardar descartados.',
  'adm.notif.event.automation_notification': 'Notificación de automatización',
  'adm.notif.event.group_member_added': 'Agregado a un grupo',
  'adm.notif.event.mention': 'Mención',
  'adm.notif.event.pending_input': 'Pendiente de respuesta',
  'adm.notif.event.sla_breach': 'Incumplimiento de SLA',
  'adm.notif.event.sla_escalation': 'Escalación de SLA',
  'adm.notif.event.sla_warning': 'Aviso de SLA',
  'adm.notif.event.ticket_assigned': 'Ticket asignado',
  'adm.notif.event.ticket_created': 'Ticket creado',
  'adm.notif.event.ticket_first_response': 'Primera respuesta',
  'adm.notif.event.ticket_group_assigned': 'Ticket asignado a un grupo',
  'adm.notif.event.ticket_note': 'Nota privada',
  'adm.notif.event.ticket_public_note': 'Nota pública',
  'adm.notif.event.ticket_reply': 'Respuesta al ticket',
  'adm.notif.event.ticket_resolved': 'Ticket resuelto',
  'adm.notif.events': 'Eventos',
  'adm.notif.eventsHelp': 'Elija un evento y la audiencia destinataria.',
  'adm.notif.insertVar': 'Insertar {variable}',
  'adm.notif.linkNoteAgent': 'La variable de enlace según la audiencia {variable} abre el espacio de trabajo del agente desde este correo.',
  'adm.notif.linkNoteCustomer': 'La variable de enlace según la audiencia {variable} abre el portal del cliente desde este correo.',
  'adm.notif.off': 'desactivado',
  'adm.notif.preview': 'Vista previa',
  'adm.notif.previewNotice': 'Vista previa generada con datos de ejemplo.',
  'adm.notif.rendering': 'Generando…',
  'adm.notif.route.all': 'Usa el enlace del ticket adaptado al destinatario según la audiencia de entrega.',
  'adm.notif.route.customer': 'La acción principal abre el ticket en el portal del cliente.',
  'adm.notif.route.internal': 'La acción principal abre el ticket en el espacio de trabajo del agente.',
  'adm.notif.sampleOnlyAgent': 'Solo datos de ejemplo: la acción principal apunta a la ruta del espacio de trabajo del agente.',
  'adm.notif.sampleOnlyCustomer': 'Solo datos de ejemplo: la acción principal apunta a la ruta del portal del cliente.',
  'adm.notif.saveChanges': 'Guardar cambios',
  'adm.notif.saved': 'Plantilla guardada.',
  'adm.notif.savedBtn': 'Guardado',
  'adm.notif.selectEvent': 'Seleccione un evento para editar su plantilla',
  'adm.notif.selectEventDesc': 'Elija un evento de notificación a la izquierda para cambiar su asunto y cuerpo.',
  'adm.notif.sendTest': 'Enviar correo de prueba',
  'adm.notif.sending': 'Enviando…',
  'adm.notif.subject': 'Asunto',
  'adm.notif.testQueued': 'Correo de prueba en cola para {email}.',
  'adm.notif.title': 'Plantillas de notificación',
  'adm.notif.urlVarTitle': 'Variable de enlace según la audiencia',
  'adm.notif.useTemplate': 'Usar esta plantilla para esta audiencia',
  'adm.notif.useTemplateHelp': 'Al desactivarla se usa la notificación alternativa segura.',
  'adm.notif.variables': 'Variables',
  'adm.notif.variablesHelp': 'Haga clic para agregar al cuerpo del mensaje',
  'adm.pagination': 'Paginación',
  'adm.perm.cap.admin.label': 'Acceder a la consola de administración',
  'adm.perm.cap.assign.label': 'Asignar un ticket',
  'adm.perm.cap.close.label': 'Cerrar un ticket',
  'adm.perm.cap.conversation_delete.label': 'Eliminar una respuesta o nota publicada',
  'adm.perm.cap.conversation_edit.label': 'Editar una respuesta o nota publicada',
  'adm.perm.cap.create.label': 'Crear un ticket',
  'adm.perm.cap.delete.label': 'Eliminar un ticket',
  'adm.perm.cap.edit.label': 'Editar las propiedades del ticket',
  'adm.perm.cap.export.label': 'Exportar tickets',
  'adm.perm.cap.field_admin.label': 'Campos del ticket',
  'adm.perm.cap.form_admin.label': 'Formularios de ticket',
  'adm.perm.cap.forward.label': 'Reenviar un ticket',
  'adm.perm.cap.jira_link.label': 'Vincular y gestionar incidencias de Jira',
  'adm.perm.cap.kb.label': 'Acceder a la base de conocimiento',
  'adm.perm.cap.manage_agents.label': 'Agentes',
  'adm.perm.cap.manage_api_keys.label': 'Claves API',
  'adm.perm.cap.manage_automations.label': 'Automatizaciones',
  'adm.perm.cap.manage_canned_responses.label': 'Respuestas guardadas',
  'adm.perm.cap.manage_email_config.label': 'Correo electrónico',
  'adm.perm.cap.manage_groups.label': 'Grupos',
  'adm.perm.cap.manage_jira.label': 'Integración con Jira',
  'adm.perm.cap.manage_kb.label': 'Base de conocimiento',
  'adm.perm.cap.manage_notification_templates.label': 'Plantillas de notificación',
  'adm.perm.cap.manage_roles.label': 'Roles',
  'adm.perm.cap.manage_tags.label': 'Etiquetas',
  'adm.perm.cap.note.label': 'Agregar o editar notas privadas',
  'adm.perm.cap.reassign.label': 'Reasignar un ticket que ya tiene otro responsable',
  'adm.perm.cap.reopen.label': 'Reabrir un ticket resuelto o cerrado',
  'adm.perm.cap.reply.label': 'Responder públicamente al cliente',
  'adm.perm.cap.report_access.label': 'Ver informes y paneles',
  'adm.perm.cap.reports.label': 'Acceder al módulo de informes',
  'adm.perm.cap.resolve.label': 'Resolver un ticket',
  'adm.perm.cap.settings_admin.label': 'Abrir la sección Configuración (necesario para ver el elemento de navegación Configuración y su página de índice; el acceso a cada página de abajo se sigue controlando de forma independiente)',
  'adm.perm.cap.sla_admin.label': 'Políticas de SLA y horario laboral',
  'adm.perm.cap.sla_edit.desc': 'Independiente del permiso de Configuración > Políticas de SLA que aparece abajo: este solo cubre la edición de las fechas límite de un ticket individual.',
  'adm.perm.cap.sla_edit.label': 'Modificar manualmente las fechas límite de SLA de un ticket',
  'adm.perm.cap.tag.label': 'Gestionar las etiquetas de los tickets',
  'adm.perm.cap.thread_start.label': 'Iniciar un hilo privado en una entrada de conversación',
  'adm.perm.cap.tickets.label': 'Acceder al espacio de trabajo de tickets',
  'adm.perm.cap.view.label': 'Ver los tickets dentro del alcance',
  'adm.perm.cat.administration.desc': 'Acceso a la consola de administración y a sus pantallas de configuración.',
  'adm.perm.cat.administration.label': 'Administración',
  'adm.perm.cat.knowledge.desc': 'Consultar y usar el contenido de conocimiento mientras se trabaja en un ticket.',
  'adm.perm.cat.knowledge.label': 'Base de conocimiento',
  'adm.perm.cat.reporting.desc': 'Informes operativos y paneles.',
  'adm.perm.cat.reporting.label': 'Informes',
  'adm.perm.cat.settings-pages.desc': 'Otorgue acceso a cada pantalla de Configuración por separado. No se muestra nada hasta que se marca aquí de forma explícita.',
  'adm.perm.cat.settings-pages.label': 'Páginas de configuración',
  'adm.perm.cat.tickets.desc': 'Lo que un agente puede hacer dentro del espacio de trabajo de tickets.',
  'adm.perm.cat.tickets.label': 'Tickets',
  'adm.previousPage': 'Página anterior',
  'adm.refresh': 'Actualizar',
  'adm.roleType.administrator': 'Administrador',
  'adm.roleType.agent': 'Agente',
  'adm.roleType.collaborator': 'Colaborador',
  'adm.roleType.customer': 'Cliente',
  'adm.roleType.super_admin': 'Superadministrador',
  'adm.roleType.supervisor': 'Supervisor',
  'adm.roles.activeHelp': 'Activo: los roles inactivos no se pueden asignar a agentes',
  'adm.roles.agentCan': 'El agente puede',
  'adm.roles.agentType': 'Tipo de agente',
  'adm.roles.agentsAssignedNote': 'Los agentes reciben este rol desde la pantalla Agentes.',
  'adm.roles.agentsCount': '{count} agentes',
  'adm.roles.agentsLabel': 'Agentes',
  'adm.roles.agentsManage': '{count} agentes - Gestionar',
  'adm.roles.builtIn': '(Integrado)',
  'adm.roles.builtInNote': 'Este es un rol integrado. Se puede renombrar y desactivar, pero no eliminar.',
  'adm.roles.builtInTitle': 'Rol integrado: se puede editar y desactivar, pero no eliminar',
  'adm.roles.categoriesAria': 'Categorías de permisos',
  'adm.roles.confirmDesc': 'Los agentes con este rol necesitarán otro rol antes de poder quitarlo.',
  'adm.roles.confirmLabel': 'Eliminar rol',
  'adm.roles.createFirst': 'Cree su primer rol',
  'adm.roles.createFirstDesc': 'Use Nuevo rol para definir las capacidades que deben tener los agentes.',
  'adm.roles.editRole': 'Editar rol',
  'adm.roles.granted': '{count} otorgados',
  'adm.roles.heading': 'Roles de agente',
  'adm.roles.inactive': 'Inactivo',
  'adm.roles.newRole': 'Nuevo rol',
  'adm.roles.noAgent': 'Sin agente',
  'adm.roles.notEnforced': '(aún no se aplica)',
  'adm.roles.notEnforcedTitle': 'Guardado en el rol, pero todavía no se controla en ninguna parte en tiempo de ejecución',
  'adm.roles.permissions': 'Permisos',
  'adm.roles.saved': 'Rol guardado.',
  'adm.roles.scopeBody': 'Las capacidades se combinan con el alcance por fila (todos / grupo / asignados / propios), de modo que un agente solo actúa sobre los tickets que ya puede ver.',
  'adm.roles.scopeTitle': 'El alcance sigue aplicando',
  'adm.roles.scrollTo': 'Ir a',
  'adm.roles.status': 'Estado',
  'adm.roles.subtitle': 'Defina y restrinja niveles detallados de acceso y privilegios para los agentes.',
  'adm.roles.title': 'Roles',
  'adm.roles.typeLocked': 'El tipo de agente no se puede cambiar una vez guardado el rol.',
  'adm.roles.understandingBody1': 'Los roles deciden qué puede hacer un agente. Cree un rol, marque las capacidades que debe otorgar y asígnelo a los agentes desde la pantalla Agentes.',
  'adm.roles.understandingBody2': 'Los roles integrados se pueden renombrar y desactivar, pero nunca eliminar. Tampoco se puede eliminar un rol que aún tenga agentes asignados, así que mueva primero a esos agentes.',
  'adm.roles.understandingTitle': 'Cómo funcionan los roles',
  'adm.saveChanges': 'Guardar cambios',
  'adm.settings.add': 'Agregar {name}',
  'adm.settings.back': 'Volver a configuración',
  'adm.settings.cannedDesc': 'Respuestas de la cuenta disponibles mientras trabaja en un ticket.',
  'adm.settings.cannedEmpty': 'Aún no hay respuestas guardadas',
  'adm.settings.cannedEmptyDesc': 'Pida a un administrador que agregue respuestas compartidas que su equipo pueda reutilizar en un ticket.',
  'adm.settings.cannedTitle': 'Respuestas guardadas',
  'adm.settings.col.autoAssign': 'Asignación automática',
  'adm.settings.col.color': 'Color',
  'adm.settings.col.content': 'Contenido',
  'adm.settings.col.createdAt': 'Fecha de creación',
  'adm.settings.col.description': 'Descripción',
  'adm.settings.col.email': 'Correo',
  'adm.settings.col.expiresAt': 'Fecha de vencimiento',
  'adm.settings.col.fieldType': 'Tipo de campo',
  'adm.settings.col.firstName': 'Nombre',
  'adm.settings.col.folderId': 'ID de carpeta',
  'adm.settings.col.hitCount': 'Número de usos',
  'adm.settings.col.holidays': 'Días festivos',
  'adm.settings.col.host': 'Host',
  'adm.settings.col.hours': 'Horario',
  'adm.settings.col.id': 'ID',
  'adm.settings.col.isActive': 'Activo',
  'adm.settings.col.isBuiltIn': 'Integrado',
  'adm.settings.col.isDefault': 'Predeterminado',
  'adm.settings.col.isRequired': 'Obligatorio',
  'adm.settings.col.isShared': 'Compartido',
  'adm.settings.col.isSystem': 'Del sistema',
  'adm.settings.col.key': 'Clave',
  'adm.settings.col.label': 'Etiqueta',
  'adm.settings.col.language': 'Idioma',
  'adm.settings.col.lastName': 'Apellidos',
  'adm.settings.col.lastUsedAt': 'Último uso',
  'adm.settings.col.name': 'Nombre',
  'adm.settings.col.options': 'Opciones',
  'adm.settings.col.phone': 'Teléfono',
  'adm.settings.col.port': 'Puerto',
  'adm.settings.col.position': 'Posición',
  'adm.settings.col.prefix': 'Prefijo',
  'adm.settings.col.priority': 'Prioridad',
  'adm.settings.col.required': 'Obligatorio',
  'adm.settings.col.role': 'Rol',
  'adm.settings.col.roleId': 'ID de rol',
  'adm.settings.col.scopes': 'Alcances',
  'adm.settings.col.slug': 'Slug',
  'adm.settings.col.status': 'Estado',
  'adm.settings.col.stopProcessing': 'Detener procesamiento',
  'adm.settings.col.timezone': 'Zona horaria',
  'adm.settings.col.title': 'Título',
  'adm.settings.col.trigger': 'Disparador',
  'adm.settings.col.type': 'Tipo',
  'adm.settings.col.updatedAt': 'Fecha de actualización',
  'adm.settings.col.usageCount': 'Número de usos',
  'adm.settings.col.username': 'Nombre de usuario',
  'adm.settings.confirmDesc': 'Esta acción no se puede deshacer.',
  'adm.settings.confirmTitle': '¿Eliminar {name}?',
  'adm.settings.count': '{count} {title}',
  'adm.settings.create': 'Crear',
  'adm.settings.empty': 'Aún no hay {title}',
  'adm.settings.emptyAdd': 'Use el formulario de arriba para agregar su primer {name}.',
  'adm.settings.emptyOther': 'Las entradas aparecerán aquí una vez que se configuren.',
  'adm.settings.homeDesc': 'Configure usuarios, flujos de trabajo de tickets, niveles de servicio e integraciones.',
  'adm.settings.manage': 'Gestionar {title}.',
  'adm.settings.noPages': 'No hay páginas de configuración disponibles',
  'adm.settings.noPagesDesc': 'Pida a un superadministrador que le otorgue acceso a las páginas de configuración que necesita.',
  'adm.settings.notFound': 'Página de configuración no encontrada',
  'adm.settings.notFoundDesc': 'Elija un área de configuración para continuar.',
  'adm.settings.res.agents.field.email': 'Correo',
  'adm.settings.res.agents.field.firstName': 'Nombre',
  'adm.settings.res.agents.field.lastName': 'Apellidos',
  'adm.settings.res.agents.field.password': 'Contraseña temporal',
  'adm.settings.res.agents.field.roleId': 'ID de rol',
  'adm.settings.res.agents.one': 'agente',
  'adm.settings.res.agents.title': 'Agentes',
  'adm.settings.res.api-keys.field.name': 'Nombre de la clave',
  'adm.settings.res.api-keys.one': 'clave API',
  'adm.settings.res.api-keys.title': 'Claves API',
  'adm.settings.res.automations.field.description': 'Descripción',
  'adm.settings.res.automations.field.name': 'Nombre',
  'adm.settings.res.automations.one': 'automatización',
  'adm.settings.res.automations.title': 'Automatizaciones',
  'adm.settings.res.business-hours.field.name': 'Nombre',
  'adm.settings.res.business-hours.field.timezone': 'Zona horaria',
  'adm.settings.res.business-hours.one': 'horario laboral',
  'adm.settings.res.business-hours.title': 'Horario laboral',
  'adm.settings.res.canned-responses.field.content': 'Contenido de la respuesta',
  'adm.settings.res.canned-responses.field.title': 'Título',
  'adm.settings.res.canned-responses.one': 'respuesta guardada',
  'adm.settings.res.canned-responses.title': 'Respuestas guardadas',
  'adm.settings.res.email.field.host': 'Host SMTP',
  'adm.settings.res.email.field.name': 'Nombre',
  'adm.settings.res.email.field.port': 'Puerto SMTP',
  'adm.settings.res.email.field.username': 'Nombre de usuario',
  'adm.settings.res.email.one': 'configuración de correo',
  'adm.settings.res.email.title': 'Configuración de correo',
  'adm.settings.res.fields.one': 'campo del ticket',
  'adm.settings.res.fields.title': 'Campos del ticket',
  'adm.settings.res.forms.field.label': 'Etiqueta visible',
  'adm.settings.res.forms.field.name': 'Nombre del campo',
  'adm.settings.res.forms.field.type': 'Tipo de campo',
  'adm.settings.res.forms.one': 'formulario o campo personalizado',
  'adm.settings.res.forms.title': 'Formularios y campos personalizados',
  'adm.settings.res.groups.field.description': 'Descripción',
  'adm.settings.res.groups.field.name': 'Nombre',
  'adm.settings.res.groups.one': 'grupo',
  'adm.settings.res.groups.title': 'Grupos',
  'adm.settings.res.jira.one': 'integración con Jira',
  'adm.settings.res.jira.title': 'Integración con Jira',
  'adm.settings.res.kb.field.content': 'Contenido del artículo',
  'adm.settings.res.kb.field.folderId': 'ID de carpeta',
  'adm.settings.res.kb.field.title': 'Título del artículo',
  'adm.settings.res.kb.one': 'artículo de la base de conocimiento',
  'adm.settings.res.kb.title': 'Administración de la base de conocimiento',
  'adm.settings.res.notification-templates.one': 'plantilla de notificación',
  'adm.settings.res.notification-templates.title': 'Plantillas de notificación',
  'adm.settings.res.roles.field.description': 'Descripción',
  'adm.settings.res.roles.field.name': 'Nombre',
  'adm.settings.res.roles.field.type': 'Tipo de rol',
  'adm.settings.res.roles.one': 'rol',
  'adm.settings.res.roles.title': 'Roles',
  'adm.settings.res.sla.field.description': 'Descripción',
  'adm.settings.res.sla.field.name': 'Nombre',
  'adm.settings.res.sla.one': 'política de SLA',
  'adm.settings.res.sla.title': 'Políticas de SLA',
  'adm.settings.res.tags.field.name': 'Nombre',
  'adm.settings.res.tags.one': 'etiqueta',
  'adm.settings.res.tags.title': 'Etiquetas',
  'adm.settings.title': 'Configuración',
  'adm.status': 'Estado',

  'sla.edit': 'Editar',
  'sla.active': 'Activa',
  'sla.inactive': 'Inactiva',
  'sla.default': 'Predeterminada',
  'sla.yes': 'Sí',
  'sla.no': 'No',
  'sla.description': 'Descripción',
  'sla.status': 'Estado',
  'sla.notConfigured': 'No configurado',
  'sla.minutesValue': '{value} minutos',
  'sla.invalidServerValue': 'Valor del servidor no válido',
  'sla.statusSemantics.title': 'Semántica de estados del ticket',
  'sla.statusSemantics.description': 'Cada estado activo tiene un contrato de SLA explícito. Un estado que pausa el SLA y uno que lo detiene son mutuamente excluyentes.',
  'sla.statusSemantics.conflict': 'Un estado no puede pausar el SLA y detenerlo al mismo tiempo.',
  'sla.statusSemantics.emptyTitle': 'No hay definiciones de estado',
  'sla.statusSemantics.emptyDescription': 'Las definiciones de estado aparecerán aquí una vez configuradas para esta cuenta.',
  'sla.statusSemantics.colPauses': 'Pausa el SLA',
  'sla.statusSemantics.colStops': 'Detiene el SLA',
  'sla.statusSemantics.pausesAria': '{label} pausa el SLA',
  'sla.statusSemantics.stopsAria': '{label} detiene el SLA',
  'sla.preview.title': 'Vista previa de ticket de solo lectura',
  'sla.preview.description': 'Ejecute el mismo evaluador, con alcance de cuenta, que usan los ciclos de SLA en vivo. Esta vista previa nunca escribe una política ni un ticket.',
  'sla.preview.priority': 'Prioridad',
  'sla.preview.group': 'Grupo',
  'sla.preview.anyGroup': 'Cualquier grupo',
  'sla.preview.company': 'Empresa',
  'sla.preview.anyCompany': 'Cualquier empresa',
  'sla.preview.source': 'Origen',
  'sla.preview.anySource': 'Cualquier origen',
  'sla.preview.ticketType': 'Tipo de ticket',
  'sla.preview.anyTicketType': 'Cualquier tipo de ticket',
  'sla.preview.representativeStart': 'Inicio representativo',
  'sla.preview.calculating': 'Calculando…',
  'sla.preview.run': 'Ejecutar vista previa',
  'sla.preview.configAttention': 'La configuración requiere atención',
  'sla.preview.selectedPolicy': 'Política seleccionada',
  'sla.preview.noPolicy': 'Sin política',
  'sla.preview.evaluationOrder': 'Orden de evaluación',
  'sla.preview.firstMatching': 'Primera política coincidente',
  'sla.preview.calculationMode': 'Modo de cálculo',
  'sla.preview.modeBusinessHours': 'Horario laboral',
  'sla.preview.modeBusinessHoursNamed': 'Horario laboral · {name}',
  'sla.preview.mode247': 'Tiempo transcurrido 24/7',
  'sla.preview.modeNone': 'No calculado',
  'sla.preview.thresholds': 'Umbrales independientes',
  'sla.preview.colMetric': 'Métrica',
  'sla.preview.colTarget': 'Objetivo',
  'sla.preview.colWarning': 'Aviso',
  'sla.preview.colDue': 'Vencimiento / incumplimiento',
  'sla.preview.colEscalation': 'Escalación',
  'sla.preview.colState': 'Estado',
  'sla.preview.metricFirstResponse': 'Primera respuesta',
  'sla.preview.metricResolution': 'Resolución',
  'sla.preview.trace': 'Traza de evaluación de políticas',
  'sla.preview.selected': 'Seleccionada',
  'sla.preview.matchedAfterSelection': 'Coincidió después de la selección',
  'sla.preview.skipped': 'Omitida',
  'sla.preview.showTrace': 'Mostrar traza del cálculo',
  'sla.state.not_configured': 'no configurado',
  'sla.state.running': 'en curso',
  'sla.state.paused': 'en pausa',
  'sla.state.warning': 'aviso',
  'sla.state.breached': 'incumplido',
  'sla.state.met': 'cumplido',
  'sla.state.escalated': 'escalado',
  'sla.state.pending': 'pendiente',
  'sla.state.stopped': 'detenido',
  'sla.state.on_track': 'en tiempo',
  'sla.state.at_risk': 'en riesgo',
  'sla.list.subtitle': 'Defina objetivos de primera respuesta y resolución por prioridad. Las políticas se evalúan de arriba abajo: gana la primera cuyas condiciones coincidan con un ticket.',
  'sla.list.newPolicy': 'Nueva política',
  'sla.list.emptyTitle': 'Cree su primera política de SLA',
  'sla.list.emptyDescription': 'Use Nueva política para definir objetivos de primera respuesta y resolución por prioridad.',
  'sla.list.moveUp': 'Mover hacia arriba',
  'sla.list.moveDown': 'Mover hacia abajo',
  'sla.list.frShort': 'PR: {value}',
  'sla.list.resolveShort': 'Resolver: {value}',
  'sla.list.escalateShort': 'Escalar: +{value}',
  'sla.list.deactivate': 'Desactivar',
  'sla.list.activate': 'Activar',
  'sla.list.setDefault': 'Establecer como predeterminada',
  'sla.list.duplicate': 'Duplicar',
  'sla.list.deleteTitle': '¿Eliminar «{name}»?',
  'sla.list.deleteDescription': 'Los tickets asociados a esta política usarán la siguiente política de SLA disponible.',
  'sla.list.deleteConfirm': 'Eliminar política',
  'sla.conditions.groups': '{count} grupo(s)',
  'sla.conditions.companies': '{count} empresa(s)',
  'sla.conditions.sources': 'orígenes: {list}',
  'sla.conditions.ticketTypes': '{count} tipo(s) de ticket',
  'sla.conditions.anyOf': 'cualquiera de',
  'sla.conditions.allOf': 'todas de',
  'sla.conditions.summary': 'Condiciones ({mode}): {parts}',
  'sla.edit.newTitle': 'Nueva política de SLA',
  'sla.edit.editTitle': 'Editar política de SLA',
  'sla.edit.saved': 'Política de SLA guardada.',
  'sla.edit.name': 'Nombre',
  'sla.edit.appliesToPriority': 'Se aplica a la prioridad',
  'sla.edit.evaluationOrder': 'Orden de evaluación',
  'sla.edit.evaluationOrderHint': 'Las posiciones más bajas se evalúan primero en esta cuenta.',
  'sla.edit.defaultPolicy': 'Política predeterminada',
  'sla.edit.useAsDefault': 'Usar como predeterminada cuando ninguna otra política coincida',
  'sla.edit.targets': 'Objetivos de SLA',
  'sla.edit.firstResponse': 'Primera respuesta',
  'sla.edit.resolution': 'Resolución',
  'sla.edit.autoAt75': 'Automático al 75%',
  'sla.edit.enabledAfter': 'Se habilita después de {value}',
  'sla.edit.clearEscalation': 'Borrar explícitamente el objetivo de escalación',
  'sla.edit.clearEscalationHint': 'Envía null; si se deja sin marcar, se omite el campo y se conserva el valor guardado.',
  'sla.edit.firstResponseMinutes': 'Primera respuesta (minutos)',
  'sla.edit.resolutionMinutes': 'Resolución (minutos)',
  'sla.edit.escalateAfter': 'Escalar después de (minutos tras el vencimiento de la resolución)',
  'sla.edit.notSet': 'Sin establecer',
  'sla.edit.remindersNote': 'Los recordatorios se envían automáticamente al 75% de las ventanas de primera respuesta y de resolución. La escalación notifica al agente de escalación del grupo del ticket (definido en el grupo) cuando se supera el objetivo de resolución por el número de minutos configurado.',
  'sla.edit.conditions': 'Condiciones',
  'sla.edit.conditionsHint': 'Deje un grupo sin marcar para que coincida con todos los valores',
  'sla.edit.matchMode': 'Modo de coincidencia:',
  'sla.edit.matchAll': 'Coincidir con TODAS las condiciones',
  'sla.edit.matchAny': 'Coincidir con CUALQUIER condición',
  'sla.edit.groups': 'Grupos',
  'sla.edit.companies': 'Empresas',
  'sla.edit.sources': 'Orígenes',
  'sla.edit.ticketTypes': 'Tipos de ticket',
  'sla.bh.subtitle': 'Defina el horario semanal y el calendario de días festivos que usan las políticas de SLA para calcular las fechas límite.',
  'sla.bh.newCalendar': 'Nuevo calendario',
  'sla.bh.emptyTitle': 'Cree su primer calendario de horario laboral',
  'sla.bh.emptyDescription': 'Use Nuevo calendario para definir el horario semanal que cuentan las políticas de SLA.',
  'sla.bh.accountDefault': 'Predeterminado de la cuenta',
  'sla.bh.closedEveryDay': 'Cerrado todos los días',
  'sla.bh.openEveryDay': 'Abierto todos los días',
  'sla.bh.openDaysOne': 'Abierto 1 día/semana',
  'sla.bh.openDaysMany': 'Abierto {count} días/semana',
  'sla.bh.holidayOne': '1 día festivo',
  'sla.bh.holidayMany': '{count} días festivos',
  'sla.bh.deleteTitle': '¿Eliminar «{name}»?',
  'sla.bh.deleteDescription': 'Las políticas de SLA y los grupos que usan este horario recurrirán al predeterminado de la cuenta.',
  'sla.bh.deleteConfirm': 'Eliminar horario',
  'sla.bh.newTitle': 'Nuevo calendario de horario laboral',
  'sla.bh.editTitle': 'Editar horario laboral',
  'sla.bh.saved': 'Horario laboral guardado.',
  'sla.bh.timezone': 'Zona horaria',
  'sla.bh.defaultCalendar': 'Calendario predeterminado',
  'sla.bh.useAsDefault': 'Usar para las políticas de SLA y los grupos que no especifiquen su propio calendario',
  'sla.bh.weeklySchedule': 'Horario semanal',
  'sla.bh.colDay': 'Día',
  'sla.bh.colOpen': 'Abierto',
  'sla.bh.colStart': 'Inicio',
  'sla.bh.colEnd': 'Fin',
  'sla.bh.dayOpenAria': '{day} abierto',
  'sla.bh.dayStartAria': 'Hora de inicio del {day}',
  'sla.bh.dayEndAria': 'Hora de fin del {day}',
  'sla.bh.holidayCalendar': 'Calendario de días festivos',
  'sla.bh.saveFirst': 'Guarde primero este calendario y luego agregue los días festivos.',
  'sla.bh.holidayName': 'Nombre del día festivo',
  'sla.bh.date': 'Fecha',
  'sla.bh.addHoliday': 'Agregar día festivo',
  'sla.bh.noHolidays': 'Aún no hay días festivos',
  'sla.bh.noHolidaysHint': 'Agregue arriba un día festivo con fecha para excluirlo de los cálculos de SLA.',
  'sla.bh.remove': 'Quitar',
  'sla.day.monday': 'Lunes',
  'sla.day.tuesday': 'Martes',
  'sla.day.wednesday': 'Miércoles',
  'sla.day.thursday': 'Jueves',
  'sla.day.friday': 'Viernes',
  'sla.day.saturday': 'Sábado',
  'sla.day.sunday': 'Domingo',

  'set.ftype.single_line_text': 'Texto de una línea',
  'set.ftype.multi_line_text': 'Texto de varias líneas',
  'set.ftype.dropdown': 'Lista desplegable',
  'set.ftype.checkbox': 'Casilla de verificación',
  'set.ftype.radio': 'Botón de opción',
  'set.ftype.multiselect': 'Selección múltiple',
  'set.ftype.lookup': 'Relación de búsqueda',
  'set.ftype.dependent': 'Campo dependiente',
  'set.ftype.date': 'Fecha',
  'set.ftype.number': 'Número',
  'set.ftype.decimal': 'Decimal',
  'set.ftype.desc.lookup': 'Seleccione un registro de una fuente del sistema.',
  'set.ftype.desc.single_line_text': 'Valor de texto corto.',
  'set.ftype.desc.multi_line_text': 'Valor de texto largo.',
  'set.ftype.desc.checkbox': 'Valor verdadero o falso.',
  'set.ftype.desc.dropdown': 'Seleccione una opción normalizada.',
  'set.ftype.desc.dependent': 'Las opciones dependen de un campo principal.',
  'set.ftype.desc.date': 'Valor de fecha de calendario.',
  'set.ftype.desc.number': 'Valor de número entero.',
  'set.ftype.desc.decimal': 'Valor de número decimal.',
  'set.src.STATIC': 'Opciones estáticas',
  'set.src.AGENTS': 'Agentes',
  'set.src.USERS': 'Usuarios / Clientes',
  'set.src.GROUPS': 'Grupos',
  'set.src.ROLE': 'Roles',
  'set.src.COUNTRIES': 'Países',
  'set.src.CUSTOM': 'Lista desplegable personalizada',
  'set.settings': 'Configuración',
  'set.ticketFields': 'Campos del ticket',
  'set.ticketForms': 'Formularios de ticket',
  'set.requestFailed': 'La solicitud falló. Inténtelo de nuevo.',
  'set.refresh': 'Actualizar',
  'set.saving': 'Guardando…',
  'set.saveChanges': 'Guardar cambios',
  'set.default': 'Predeterminado',
  'set.published': 'Publicado',
  'set.draft': 'Borrador',
  'set.publish': 'Publicar',
  'set.unpublish': 'Anular publicación',
  'set.deleteForm': 'Eliminar formulario',
  'set.description': 'Descripción',
  'set.relationshipSource': 'Fuente de la relación',
  'set.dependsOn': 'Depende de {field}',
  'set.deleteFormTitle': '¿Eliminar «{name}»?',
  'set.deleteFormDescription': 'Este formulario de ticket y su configuración se eliminarán de forma permanente.',
  'set.formIdRequired': 'Se requiere un ID de formulario.',
  'set.formNotFound': 'Formulario de ticket no encontrado.',
  'set.tf.removeOption': 'Quitar {label}',
  'set.tf.noOptions': 'Aún no se han definido opciones.',
  'set.tf.addOptionPlaceholder': 'Agregar opción...',
  'set.tf.add': 'Agregar',
  'set.tf.dependsOnField': 'Depende del campo',
  'set.tf.selectParent': '— Seleccionar campo principal —',
  'set.tf.parentHelp': 'El campo de lista desplegable principal cuyo valor seleccionado determina las opciones disponibles de este campo.',
  'set.tf.optionMappings': 'Asignaciones de opciones',
  'set.tf.savingParen': '(guardando...)',
  'set.tf.mappingsError': 'No se pudieron cargar las asignaciones',
  'set.tf.archivedParen': ' (archivado)',
  'set.tf.mappedCount': '{count} asignadas',
  'set.tf.saveFirst': 'Guarde primero el campo para configurar las asignaciones de opciones.',
  'set.tf.newField': 'Nuevo {type}',
  'set.tf.pageDescription': 'Gestione las definiciones de campos importadas, su visibilidad, las reglas de obligatoriedad y el orden que usan los formularios de ticket.',
  'set.tf.addField': 'Agregar campo',
  'set.tf.addFieldHelp': 'Arrastre un tipo a la lista de campos o use Agregar.',
  'set.tf.addType': 'Agregar {type}',
  'set.tf.registry': 'Registro de campos',
  'set.tf.savingOrder': 'Guardando orden…',
  'set.tf.searchAria': 'Buscar campos del ticket',
  'set.tf.searchPlaceholder': 'Buscar por nombre o clave...',
  'set.tf.filterAria': 'Filtrar por tipo de campo',
  'set.tf.allTypes': 'Todos los tipos de campo',
  'set.tf.emptyFirstTitle': 'Agregue su primer campo del ticket',
  'set.tf.emptyFirstDesc': 'Arrastre un tipo de campo desde la paleta o use Agregar para crear uno.',
  'set.tf.emptyFilterTitle': 'Ningún campo coincide con estos filtros',
  'set.tf.emptyFilterDesc': 'Pruebe con otro término de búsqueda o amplíe el filtro de tipo de campo.',
  'set.tf.archived': 'Archivado',
  'set.tf.dependent': 'Dependiente',
  'set.tf.customerVisible': 'Visible para el cliente',
  'set.tf.internal': 'Interno',
  'set.tf.configuration': 'Configuración del campo',
  'set.tf.selectTitle': 'Seleccione un campo para configurarlo',
  'set.tf.selectDesc': 'Elija un campo del registro para editar sus etiquetas, reglas y visibilidad.',
  'set.tf.externalId': 'ID externo: {value}',
  'set.tf.sourceRenderer': 'Fuente: {source} · Renderizador: {renderer}',
  'set.tf.optionSource': 'Fuente de opciones: {value}',
  'set.tf.dependsOnKey': 'Depende de: {value}',
  'set.tf.internalLabel': 'Etiqueta interna',
  'set.tf.customerLabel': 'Etiqueta para el cliente',
  'set.tf.relationshipHelp': 'Determina de dónde se obtienen los valores de búsqueda en tiempo de ejecución.',
  'set.tf.validationVisibility': 'Validación y visibilidad',
  'set.tf.requiredAgents': 'Obligatorio para agentes',
  'set.tf.requiredCustomers': 'Obligatorio para clientes',
  'set.tf.requiredClosure': 'Obligatorio para el cierre',
  'set.tf.displayedCustomers': 'Se muestra a los clientes',
  'set.tf.customersEdit': 'Los clientes pueden editar',
  'set.tf.customersFilter': 'Los clientes pueden filtrar',
  'set.tf.active': 'Activo',
  'set.tf.dropdownOptions': 'Opciones de la lista desplegable ({count})',
  'set.tf.archiveTitle': '¿Archivar «{name}»?',
  'set.tf.archiveDesc': 'El campo quedará inactivo y no estará disponible para tickets nuevos. Los datos de los tickets existentes se conservan.',
  'set.tf.archiveField': 'Archivar campo',
  'set.tf.alreadyArchived': 'Ya archivado',
  'set.tf.archivedNote': 'Los campos archivados siguen disponibles para los valores históricos.',
  'set.tfm.systemUser': 'Sistema',
  'set.tfm.untitled': 'Formulario sin título',
  'set.tfm.pageDescription': 'Cree formularios reutilizables y elija qué campos importados pueden usar los agentes y los clientes.',
  'set.tfm.newForm': 'Nuevo formulario',
  'set.tfm.creating': 'Creando…',
  'set.tfm.allForms': 'Todos los formularios',
  'set.tfm.configuredOne': '{count} formulario configurado',
  'set.tfm.configuredMany': '{count} formularios configurados',
  'set.tfm.filter': 'Filtro',
  'set.tfm.searchAria': 'Buscar formularios de ticket',
  'set.tfm.searchPlaceholder': 'Buscar formularios…',
  'set.tfm.status': 'Estado',
  'set.tfm.allStatuses': 'Todos los estados',
  'set.tfm.emptyFilterTitle': 'Ningún formulario coincide con estos filtros',
  'set.tfm.emptyFilterDesc': 'Pruebe con otro término de búsqueda o amplíe el filtro de estado.',
  'set.tfm.emptyFirstTitle': 'Cree su primer formulario de ticket',
  'set.tfm.emptyFirstDesc': 'Cree un formulario para empezar a configurar los campos importados.',
  'set.tfm.createFirst': 'Cree su primer formulario',
  'set.tfm.colName': 'Nombre',
  'set.tfm.colCreatedAt': 'Fecha de creación',
  'set.tfm.colUpdatedBy': 'Última actualización por',
  'set.tfm.colUpdatedAt': 'Fecha de última actualización',
  'set.tfm.colPortals': 'Portales asociados',
  'set.tfm.colActions': 'Acciones',
  'set.tfm.notConfigured': 'No configurado',
  'set.tfm.actionsFor': 'Acciones para {name}',
  'set.tfm.editForm': 'Editar formulario',
  'set.tb.section.default.title': 'Campos predeterminados',
  'set.tb.section.default.desc': 'Campos básicos del flujo de soporte importados del sistema de origen.',
  'set.tb.section.custom.title': 'Campos personalizados',
  'set.tb.section.custom.desc': 'Campos adicionales configurados para su proceso de soporte.',
  'set.tb.section.nested.title': 'Campos anidados',
  'set.tb.section.nested.desc': 'Campos dependientes cuyas opciones siguen a un campo principal.',
  'set.tb.discardTitle': '¿Descartar los cambios sin guardar?',
  'set.tb.discardDesc': 'Sus ediciones a este formulario de ticket no se han guardado.',
  'set.tb.leave': 'Salir sin guardar',
  'set.tb.nameRequired': 'El nombre del formulario es obligatorio.',
  'set.tb.saved': 'Formulario guardado.',
  'set.tb.nowPublished': 'Formulario publicado.',
  'set.tb.nowUnpublished': 'Publicación del formulario anulada.',
  'set.tb.admin': 'Administración',
  'set.tb.builder': 'Constructor',
  'set.tb.titleAria': 'Título del formulario',
  'set.tb.defaultLocked': 'Predeterminado / bloqueado',
  'set.tb.previewPortal': 'Vista previa en el portal',
  'set.tb.configureTitle': 'Configure los campos incluidos en este formulario.',
  'set.tb.configureDesc': 'Los cambios se guardan en la base de datos del centro de soporte al seleccionar Guardar cambios. Los campos obligatorios permanecen habilitados.',
  'set.tb.formDetails': 'Detalles del formulario',
  'set.tb.formDetailsHelp': 'Use una descripción clara para que los administradores sepan cuándo usar este formulario.',
  'set.tb.descPlaceholder': 'Describa cuándo debe usarse este formulario…',
  'set.tb.importedFields': 'Campos importados',
  'set.tb.importedHelp': 'Arrastre para reordenar los campos. Use el interruptor para incluir o excluir un campo de este formulario.',
  'set.tb.noneInSection': 'No hay campos importados en esta sección.',
  'set.tb.dragReorder': 'Arrastre para reordenar',
  'set.tb.required': 'Obligatorio',
  'set.tb.nested': 'Anidado',
  'set.tb.enableField': 'Habilitar {label}',
  'set.tb.enabled': 'Habilitado',
  'set.tb.disabled': 'Deshabilitado',
  'set.tb.emptyTitle': 'Aún no hay campos que configurar',
  'set.tb.emptyDesc': 'Importe campos del ticket para empezar a crear este formulario.',
  'set.tb.deleting': 'Eliminando…',
  'set.tp.loadError': 'No se pudo cargar la vista previa del formulario.',
  'set.tp.preview': 'Vista previa',
  'set.tp.customerPreview': 'Vista previa para el cliente',
  'set.tp.backToBuilder': 'Volver al constructor',
  'set.tp.modeTitle': 'Modo de vista previa',
  'set.tp.modeDesc': 'Esta es una vista previa sin envío. Se muestran todos los campos habilitados en el orden guardado del formulario.',
  'set.tp.emptyTitle': 'Aún no hay campos habilitados',
  'set.tp.emptyDesc': 'Habilite campos en el constructor de formularios para verlos en esta vista previa.',

  'por.error.generic': 'No se pudo completar la solicitud.',
  'por.error.requestNotFound': 'Solicitud no encontrada.',
  'por.error.formUnavailable': 'El formulario de solicitud no está disponible.',
  'por.error.articleNotFound': 'Artículo no encontrado.',
  'por.error.selectRating': 'Seleccione una calificación del 1 al 5.',
  'por.tab.all': 'Todas',
  'por.list.title': 'Mis solicitudes de soporte',
  'por.list.description': 'Dé seguimiento a sus solicitudes y responda al equipo de soporte.',
  'por.list.newRequest': 'Nueva solicitud',
  'por.list.knowledgeBase': 'Base de conocimiento',
  'por.list.filterByStatus': 'Filtrar solicitudes por estado',
  'por.list.searchPlaceholder': 'Buscar por asunto…',
  'por.list.count': '{count} solicitudes',
  'por.list.countOne': '{count} solicitud',
  'por.list.emptyFilteredTitle': 'Ninguna solicitud coincide con esta vista',
  'por.list.emptyTitle': 'Aún no hay solicitudes',
  'por.list.emptyFilteredDescription': 'Pruebe la pestaña Todas o con otro término de búsqueda.',
  'por.list.emptyDescription': 'Envíe una solicitud y el equipo de soporte la atenderá.',
  'por.list.submitFirst': 'Envíe su primera solicitud',
  'por.col.request': 'Solicitud',
  'por.col.subject': 'Asunto',
  'por.col.status': 'Estado',
  'por.col.priority': 'Prioridad',
  'por.col.created': 'Creada',
  'por.detail.myRequests': 'Mis solicitudes',
  'por.detail.reopen': 'Reabrir esta solicitud',
  'por.detail.attachments': 'Archivos adjuntos',
  'por.detail.download': 'Descargar',
  'por.detail.conversation': 'Conversación',
  'por.detail.noReplies': 'Aún no hay respuestas',
  'por.detail.noRepliesHint': 'Agregue una respuesta abajo y el equipo de soporte la atenderá.',
  'por.detail.reply': 'Responder',
  'por.detail.replyPlaceholder': 'Escriba una respuesta',
  'por.detail.sending': 'Enviando…',
  'por.detail.sendReply': 'Enviar respuesta',
  'por.file.sizeKb': '{size} KB',
  'por.file.remove': 'Quitar {name}',
  'por.submit.newRequest': 'Nueva solicitud',
  'por.submit.defaultTitle': 'Enviar una solicitud de soporte',
  'por.submit.intro': 'Complete los campos de abajo y envíe su solicitud.',
  'por.submit.subjectRequired': 'El asunto es obligatorio',
  'por.submit.descriptionRequired': 'La descripción es obligatoria',
  'por.submit.attachments': 'Archivos adjuntos',
  'por.submit.submitting': 'Enviando…',
  'por.submit.submit': 'Enviar solicitud',
  'por.kb.portal': 'Portal',
  'por.kb.title': 'Base de conocimiento',
  'por.kb.description': 'Encuentre respuestas antes de enviar una solicitud.',
  'por.kb.crumbRoot': 'KB',
  'por.kb.searchResults': 'Resultados de búsqueda',
  'por.kb.searchPlaceholder': 'Buscar artículos',
  'por.kb.emptyTitle': 'Aún no hay artículos publicados',
  'por.kb.emptyDescription': 'Envíe una solicitud y el equipo de soporte le ayudará directamente.',
  'por.kb.noFolders': 'No hay carpetas',
  'por.kb.articles': '{count} artículos',
  'por.kb.articlesOne': '{count} artículo',
  'por.kb.noMatch': 'Ningún artículo coincide con «{query}»',
  'por.kb.folderEmpty': 'Aún no hay artículos en esta carpeta',
  'por.kb.noMatchHint': 'Pruebe con un término de búsqueda más corto o envíe una solicitud.',
  'por.kb.folderEmptyHint': 'Explore otra carpeta o envíe una solicitud.',
  'por.kb.submitRequest': 'Enviar una solicitud',
  'por.kb.views': '{count} vistas',
  'por.kb.thanks': '¡Gracias por sus comentarios!',
  'por.kb.helpful': '¿Le resultó útil?',
  'por.kb.yes': 'Sí',
  'por.kb.no': 'No',
  'por.csat.thanksTitle': 'Gracias por sus comentarios',
  'por.csat.thanksBody': 'Su respuesta ha sido registrada.',
  'por.csat.title': '¿Cómo lo hicimos?',
  'por.csat.request': 'Solicitud n.º {number}: {subject}',
  'por.csat.rating': 'Calificación',
  'por.csat.stars': '{count} estrellas',
  'por.csat.comment': 'Comentario',
  'por.csat.submit': 'Enviar comentarios',
  'agents.tempPassword.title': 'Contraseña temporal',
  'agents.tempPassword.help': 'Establezca una contraseña temporal para este agente. Se le pedirá elegir una nueva contraseña la próxima vez que inicie sesión. Mínimo 12 caracteres.',
  'agents.tempPassword.button': 'Establecer contraseña temporal',
  'agents.tempPassword.saving': 'Estableciendo…',
  'agents.tempPassword.error': 'No se pudo establecer la contraseña temporal.',
  'ui.showPassword': 'Mostrar contraseña',
  'ui.hidePassword': 'Ocultar contraseña',
  'dashboard.awaitingResolutionConfirmation': 'Esperando confirmación de la resolución',
  'dashboard.awaitingUserReply': 'Esperando respuesta del usuario',
  'dashboard.changeRequests': 'Solicitudes de cambio',
  'agents.tempPassword.successEmailed': 'Contraseña temporal establecida y enviada por correo al agente.',
  'agents.tempPassword.successNotEmailed': 'Contraseña temporal establecida, pero no se pudo enviar el correo. Comparta la contraseña con el agente por un canal seguro.',
} as const;

export default es;
